const messages = {
  pt: {
    translations: {
      titles: {
        home: 'Home',
        resources: 'Recursos',
        teaching: 'Ensino',
        support: 'Suporte',
        language: 'Idioma',
        contents: 'Conteúdo',
        integration: 'Integração',
        contact: 'Contato',
        compliance: 'Compliance',
        signup: 'Cadastre-se',
        signupSuccess: 'Cadastro Realizado',
        signin: 'Fazer Login',
        login: 'Login',
        finalizeAccount: 'Finalize seu cadastro',
        guardianData: 'Dados do Responsável',
        forgotPassword: 'Redefinir senha',
        institutionalAccess:
          'Como acessar pelo portal da sua institui\u00e7\u00e3o',
        searchResults: 'Resultados da pesquisa',
        pageNotFound: 'Página não encontrada',
        adjustImage: 'Ajuste sua foto',
        account: 'Perfil',
        admin: 'Admin',
        help: 'Ajuda',
        rate: 'Avaliar',
        rated: 'Avaliado',
        rateQuestion: 'O que você achou desse conteúdo?',
        profileData: 'Dados Pessoais',
        permissions: 'Notificações e Permissões',
        plan: 'Plano',
        config: 'Configurações',
        mouse: 'Mouse',
        keyboard: 'Teclado',
        trackpad: 'Trackpad',
        organs: 'Órgãos e sistemas',
        completeAnatomy: 'Anatomia\nCompleta',
        topographicAnatomy: 'Anatomia\nTopográfica',
        systemicAnatomy: 'Anatomia\nSistêmica',
        cellStructure: 'Células e tecidos',
        cytology: 'Citologia',
        histology: 'Histologia',
        histopathology: 'Histopatologia',
        development: 'Funções corporais e desenvolvimento',
        embryology: 'Embriologia',
        physiology: 'Fisiologia',
        specialties: 'Clínica integrada',
        radiology: 'Radiologia',
        pathology: 'Patologia',
        api: 'API BioAtlas',
        institutions: 'Instituições',
        whiteLabel: 'White Label',
        VR: 'Realidade Virtual 3D',
        multiplatform: 'Multiplataforma',
        animations: 'Animações Interativas 3D',
        accessControl: 'Controle de Acesso',
        languages: 'Disponível em 3 línguas',
        platform:
          'Transforme a maneira como sua instituição ensina ciências da saúde.',
        modules:
          'Diversos módulos para Ensino em Saúde em uma única plataforma',
        cadaver: 'Cadáver Virtual',
        cadaver3D: 'Cadáver Virtual 3D',
        atlas3D: 'Atlas Anatômico 3D',
        blades: 'Lâminas Histologia e Histopatologia',
        cardiacCycle: 'Ciclo Cardíaco do Coração',
        fiberContraction: 'Contração da Fibra Muscular',
        potentialGeneration: 'Geração e Condução de Potencial de Ação',
        hematosis: 'Hematose',
        synapticTransmission: 'Transmissão Sináptica',
        lungVentilation: 'Ventilação Pulmonar',
        pathophysiology: 'Fisiopatologia',
        'pathologicalConditions.1': 'Acne',
        'pathologicalConditions.2': 'Afecções pleurais',
        'pathologicalConditions.3': 'Anemia falciforme',
        'pathologicalConditions.4': 'Asma',
        'pathologicalConditions.5': 'Cardiopatia isquêmica',
        'pathologicalConditions.6': 'Desvios da coluna vertebral',
        'pathologicalConditions.7': 'Diabete mellitus Tipo 01',
        'pathologicalConditions.8': 'Diabete mellitus Tipo 02',
        'pathologicalConditions.9': 'Distensão muscular',
        'pathologicalConditions.10': 'Doença de Graves',
        'pathologicalConditions.11': 'Doença ulcerosa péptica',
        'pathologicalConditions.12': 'Gastrite',
        'pathologicalConditions.13': 'Fraturas ósseas',
        'pathologicalConditions.14': 'Pneumonia',
        'pathologicalConditions.15': 'Síndrome do ovário policístico',
        'pathologicalConditions.16': 'Sinusite',
        'pathologicalConditions.17': 'Tireoidite de Hashimoto',
        'pathologicalConditions.18': 'Trombose',
        'pathologicalConditions.19': 'Tromboembolismo pulmonar',
        'pathologicalConditions.20': 'Tuberculose',
        'pathologicalConditions.21': 'Urticária',
        'histopathology.1': 'Doenças do Sistema respiratório',
        'histopathology.2': 'Doenças do Sistema cardiovascular',
        'histopathology.3': 'Doenças do Sistema digestório',
        'histopathology.4': 'Distúrbios da circulação sanguínea',
        'histopathology.5': 'Tumor',
        'histopathology.6': 'Doenças do Sistema nervoso',
        'histopathology.7': 'Doenças do Sistema genital',
        'histopathology.8': 'Doenças do Sistema urogenital',
        'histopathology.9': 'Inflamação',
        'histopathology.10': 'Lesão e reparo de células e tecidos',
        'histopathology.11': 'Doenças do Sistema endócrino',
        'histopathology.12': 'Doenças imunológicas',
        'histopathology.13': 'Doenças dos Sistemas muscular e esquelético',
        'histopathology.14': 'Doenças do Sistema hematopoiético',
        cardiology: 'Cardiologia / Urgências Cardiológicas',
        firstAid: 'Pronto Socorro',
        pulmonology: 'Pneumologia',
        infectology: 'Infectologia',
        neurology: 'Neurologia',
        vascular: 'Vascular',
        autoImmune: 'Reumato / Autoimune',
        survey: 'Olá, nos ajude a melhorar o BioAtlas?',
        collections: 'Coleções',
        learningPaths: 'Trilhas',
        deleteCollections: 'Deseja deletar ',
        shareCollection: 'Compartilhar Conteúdos para ',
        addToMyCollection: 'Adicionar para minha coleção',
        explore: 'Explorar',
        forTeachers: 'Para Professores',
        forStudents: 'Para Alunos',
        app: 'Aplicativo',
        viewer3d: 'Visualizador 3D',
        slideViewer: 'Visualizador de lâminas',
        radiologyViewer: 'Visualizador Radiologia',
        biochemistry: 'Bioquímica',
        'features.collections': 'Compartilhamento de coleções',
        'features.multiplatform': 'Multiplataforma',
        'features.laboratory': 'Redução de Custos com Laboratório',
        'features.support': 'Suporte à Pesquisa e Estudos de Caso',
        'features.integration': 'Integração',
        'features.languages': 'Disponível em 3 línguas',
        pathologicalConditions: 'Condições patológicas',
        'radiology.1': 'Tomografias computadorizadas',
        'radiology.2': 'Ressonâncias magnéticas',
        'radiology.3': 'Radiografias computadorizadas',
        'radiology.4': 'Raio-X',
        'radiology.5': 'Ultrassom',
        'cytology1.1': 'Vírus',
        'cytology1.2': 'Célula bacteriana',
        'cytology1.3': 'Célula Eucarionte de origem animal',
        'cytology1.4': 'Célula do sistema imunológico',
        'cytology1.5': 'Neurônio',
        'cytology1.6': 'Célula adiposa',
        'cytology1.7': 'Sistema ABO',
        'cytology1.8': 'Célula sanguínea',
        'cytology1.9': 'Fibra Muscular',
        'cytology1.10': 'Ilhotas de Langerhans',
        'cytology1.11': 'Folículo Tireoidiano',
        'cytology2.1': 'Difusão Simples',
        'cytology2.2': 'Difusão facilitada',
        'cytology2.3': 'Bomba de sódio e potássio',
        'cytology2.4': 'Cotransporte',
        'cytology2.5': 'Contratransporte',
        integrations: 'Integrações'
      },
      subtitles: {
        signup: 'Preencha as informações para cadastrar',
        validationSent: 'Informações enviadas para o email',
        signin: 'Preencha suas informações abaixo.',
        finalizeAccount: 'Preencha as informações restantes',
        fillInfo: 'Preencha as informações abaixo:',
        resetPassword: 'Você precisa alterar sua senha:',
        resetToken: 'Preencha as informações para redefinir sua senha',
        selectInstitution:
          'Selecione sua instituição para ver o tutorial específico.',
        pageNotFound: 'Desculpe, ocorreu algum erro na nossa página.',
        rightsReserved: 'Todos os direitos reservados.',
        aboutMedicalHarbour1:
          'O BioAtlas é um produto da Medical Harbour, uma empresa de tecnologia que',
        aboutMedicalHarbour2:
          'desenvolve soluções digitais para facilitar o aprendizado em saúde através de conteúdos interativos e 3D.',
        aboutMedicalHarbour3:
          'Conheça nossas soluções para instituições de Ensino de Saúde:',
        aboutMedicalHarbourDesktop1:
          'O BioAtlas é um produto da Medical Harbour, uma empresa de tecnologia que desenvolve soluções',
        aboutMedicalHarbourDesktop2:
          'digitais para facilitar o aprendizado em saúde através de conteúdos interativos e 3D. Conheça nossas',
        aboutMedicalHarbourDesktop3:
          'soluções para instituições de Ensino de Saúde:',
        tabText: 'Conteúdos Digitais Interativos para Saúde',
        group: 'Somos uma empresa do Grupo Afya',
        sales: 'Entre em contato com nossa equipe de venda',
        detail: 'Informações',
        rotate: 'Rotacionar',
        moreTools: 'Mais ferramentas',
        pin: 'Pin',
        ruler: 'Régua',
        arrow: 'Seta',
        savePin: 'Salvar pin',
        saveArrow: 'Salvar seta',
        saveRectangle: 'Salvar retângulo',
        fullscreen: 'Tela cheia',
        info: 'Informações',
        move: 'Mover',
        select: 'Selecionar',
        camera: 'Movimentar câmera',
        zoom: 'Zoom',
        resetZoom: 'Redefinir zoom',
        deselect: 'Delete seleção',
        focus: 'Focar',
        selectMultiple: 'Seleciona vários',
        hide: 'Esconder',
        help: 'Ajuda',
        nextChapter: 'Próximo capítulo',
        previousChapter: 'Capítulo anterior',
        save: 'Salvar',
        saveNew: 'Salvar novo',
        animationPanel: 'Painel de animação',
        recentralize: 'Recentralizar',
        undoAction: 'Desfazer ação',
        advanceAction: 'Avançar ação',
        reset: 'Redefinir',
        playPause: 'Play/Pause',
        restartAnimation: 'Reinicar animação',
        speed: 'Velocidade',
        ClosePanelMinimize: 'Fechar painel/minimizar',
        basicTools: 'Ferramentas básicas',
        animationControl: 'Controle de animação',
        isolate: 'Isolar',
        tree: 'Árvore de anatomia',
        textbox: 'Caixa de texto',
        tag: 'Etiqueta',
        cutTool: 'Ferramenta de corte',
        turn: 'Virar',
        menu: 'Menu',
        increaseZoom: 'Aumentar o zoom',
        decreaseZoom: 'Diminuir o zoom',
        originalZoom: 'Reposicionar',
        bladeMessage:
          'Para que os atalhos funcionem, primeiro clique no visualizador e depois pressione a tecla',
        organ: 'Órgão',
        tissue: 'Tecido',
        color: 'Coloração',
        section: 'Seção',
        partners1: 'Junte-se a mais de',
        partners2: 'instituições de Ensino em',
        partners3: 'países pelo mundo',
        completeAnatomy:
          'Ofereça a base curricular definitiva em Anatomia Humana.',
        completeAnatomy2: `Acesse o <b>Cadáver Virtual</b> e o <b>Atlas 3D</b> para uma navegação detalhada. Este módulo abrangente conta <b>com mais de 2.500 estruturas</b> classificadas, organizadas em 12 sistemas e 9 regiões, e disponíveis nos modelos <b>Masculino e Feminino. Garanta a qualidade e a padronização</b> do ensino em todas as disciplinas de Ciências da Saúde.`,
        completeAnatomy3:
          'A Anatomia Humana é a ciência que estuda a morfologia e a organização do corpo humano, através da observação e análise das estruturas macroscópicas constituintes. Essa análise está correlacionada com o funcionamento das várias partes e os mecanismos de formação e de resposta aos fatores ambientais, genéticos e temporais. Pode ser categorizada, a partir da separação das peças, em Sistemas Orgânicos e Regiões Anatômicas. Nesse módulo, foram contemplados modelos anatômicos representativos do corpo masculino e do feminino, além do cadáver virtual masculino.',
        completeAnatomy4:
          'Conta com mais de 2500 estruturas de todos os sistemas anatômicos do corpo humano etiquetados. Este módulo está separado em modelo Masculino e Feminino e organizado de acordo com 12 sistemas anatômicos e 9 regiões.',
        completeAnatomy5:
          'Um corpo humano* real dividido em 1878 fatias e fotografado com equipamento de altíssima resolução reconstruído digitalmente em 3D. O Cadáver Virtual possui as cores preservadas, está segmentado e mapeado para visualização completa.',
        topographicAnatomy: 'O Laboratório de Anatomia do Futuro',
        topographicAnatomy2:
          'Transforme a Anatomia Topográfica em uma experiência interativa e totalmente segura. Com a separação do corpo humano em regiões, você irá facilitar para o aluno a compreensão das relações anatômicas entre estruturas de todos os sistemas em um segmento do corpo.',
        topographicAnatomy3:
          'A Anatomia Topográfica trata do estudo da separação do corpo humano em regiões, a fim de facilitar a compreensão das relações anatômicas entre estruturas de todos os sistemas num determinado segmento do corpo. Esse método auxilia o domínio da topografia geral dos órgãos a partir da percepção de funcionamento e localização de todas as peças próximas e relacionadas. Nesse módulo, foram contempladas as regiões anatômicas: Elementos Descritivos do Crânio e pelas regiões anatômicas: cabeça e pescoço, membro superior direito, membro superior esquerdo, dorso, tórax, abdome, pelve, membro inferior direito e membro inferior esquerdo.',
        systemicAnatomy: 'Visualização 3D Abrangente e Ensino Ativo',
        systemicAnatomy2:
          'Com nossa tecnologia 3D, os estudantes exploram todos os sistemas (esquelético, muscular, nervoso, etc.) com clareza e precisão, otimizando o tempo de estudo e aprimorando a retenção do conteúdo. Esta ferramenta dispensa a necessidade de gastos adicionais com peças e modelos, garantindo a excelência do ensino sem sobrecarregar o orçamento da sua instituição.',
        systemicAnatomy3:
          'A Anatomia Sistêmica trata do estudo analítico dos sistemas orgânicos do corpo humano, estabelecendo conjuntos de órgãos e peças anatômicas que executam, de maneira integrada, as mesmas funções nos mecanismos biológicos. Apesar de cada sistema realizar uma tarefa distinta, todos estão interligados, garantindo o funcionamento e a sobrevivência do organismo como um todo. Nesse módulo, foram considerados os sistemas: Arterial, Articular, Digestório, Endócrino, Esquelético, Linfático, Muscular, Nervoso, Respiratório, Tegumentar, Urogenital e Venoso.',
        cytology: 'O Laboratório Virtual que Otimiza Seus Custos',
        cytology2:
          'Garanta eficiência e elimine despesas recorrentes de laboratório. O módulo de Citologia permite explorar as estruturas celulares em detalhe, com interatividade de ponta. Por ter acesso online, você dispensa a manutenção de microscópios, oferecendo uma ferramenta de ensino ativa que facilita o sucesso do aluno no ciclo básico.',
        cytology3:
          'O módulo de Citologia permite ao usuário interagir com duas categorias de conteúdos 3D: Células e Membrana Celular. Navegue nas células:',
        cytology4:
          'Visualize um modelo de Membrana Celular em 3D e animações relacionadas ao transporte de moléculas pela membrana: ',
        histology:
          'Reduza custos de manutenção e ofereça uma prática ilimitada',
        histology2:
          'O módulo de Histologia atua como um laboratório de microscopia virtual completo, permitindo que diversos tipos de tecidos, sistemas e órgãos sensoriais sejam explorados com recursos de aumento digital e identificação de estruturas, eliminando custos com lâminas e equipamentos caros.',
        histology3:
          'O BioAtlas possui um módulo dedicado ao estudo de lâminas com mais de 300 exemplos de glândulas, órgãos, tecidos e sistemas, e lâminas com patologias. Além de possuir uma ferramenta com recursos para visualização e análise das mesmas com zoom de até 40x, marcação nas lâminas, espelhamento, etc.',
        embryology:
          'A Ferramenta para o Entendimento do Desenvolvimento Embrionário',
        embryology2:
          'Garanta aos seus alunos uma visão completa e interativa do desenvolvimento humano — da formação dos gametas até a gravidez e a placenta em detalhe. Com recursos 3D imersivos e conteúdos que cobrem cada etapa embrionária e fetal, o BioAtlas transforma disciplinas complexas em experiências didáticas acessíveis, reduzindo custos de laboratório e fortalecendo a qualidade do ensino em saúde da sua instituição.',
        embryology3:
          'Acompanhe o desenvolvimento embrionário e fetal, a partir da ovogênese/espermatogênese até o nascimento, através de animações interativas 3D do Período Embrionário do Desenvolvimento e do Período Fetal do Desenvolvimento',
        physiology: 'Mais sucesso para seus estudantes em todas as provas',
        physiology2:
          'O módulo de Fisiologia detalha o funcionamento do corpo humano e seus estágios de desenvolvimento, permitindo que você crie coleções e estudos de caso com dinamismo, preparando os alunos para a clínica prática e fortalecendo a qualidade do ensino da sua instituição.',
        physiology3:
          'Explore o funcionamento e as funções normais do corpo humano, através de conteúdos virtuais 3D interativos:',
        radiology: 'Ferramenta Essencial para o Raciocínio Diagnóstico',
        radiology2:
          'Prepare seus estudantes para a prática clínica com o módulo de Radiologia, que permite a visualização interativa de Tomografias, Ressonâncias e Raio-X, oferecendo imagens reais e a possibilidade de comparação de exames. Promova a associação de conteúdos, transformando o aprendizado em experiência ativa e garanta que sua instituição ofereça o que há de mais moderno na formação em saúde.',
        radiology3:
          'Sistema para visualização de imagens DICOM com ferramentas para manipulação de estudos e casos clínicos radiológicos. Permite visualizar imagens de diversas modalidades como:',
        pathology:
          'Desenvolva o Raciocínio Clínico-Epidemiológico do seu aluno',
        pathology2:
          'O módulo de Patologia, com lâminas histopatológicas virtuais e modelos interativos, facilita o estudo de diversas alterações morfológicas e funcionais, além de preparar seus alunos para a clínica. Garanta que sua instituição promova o desenvolvimento do raciocínio clínico-epidemiológico.',
        pathology3:
          'Esse módulo contempla animações tridimensionais que representam processos fisiológicos não saudáveis (patológicos), destacando as alterações que acontecem no corpo nessas condições.',
        features:
          'Navegue através dos detalhes do Corpo Humano a qualquer hora, em qualquer lugar!',
        VR: 'Envolva alunos e professores através do ambiente imersivo da Realidade Virtual',
        multiplatform:
          'Acesse através de qualquer navegador web, aplicativo Android ou iOS',
        animations:
          'Diversos conteúdos com animações 3D guiadas para fácil compreensão',
        accessControl:
          'Habilite, controle e analise os acessos de professores e alunos',
        integration: 'Embarque nosso conteúdo em seu site através de nossa API',
        languages:
          'Conteúdo mapeado e traduzido para português, espanhol e inglês',
        testimonial0_0:
          'O BioAtlas é uma excelente ferramenta para que o aluno integre os diferentes conteúdos das ciências biológicas e da saúde',
        testimonial0_1:
          'Professor de Fisiologia Humana e Neurociências na FMIT',
        newsletter:
          'Converse com nossa equipe e explore o BioAtlas, pensado para apoiar e inovar nas instituições de medicina.',
        platform:
          'O BioAtlas reúne em uma única plataforma anatomia humana 3D, laboratórios virtuais, ferramentas de ensino colaborativas e outros conteúdos interativos para proporcionar uma experiência de aprendizagem em saúde de forma imersiva e eficiente.',
        modules:
          'Um ambiente virtual com milhares de possibilidades. Conteúdos referentes ao ensino da anatomia humana, como o Atlas Anatômico Humano Virtual 3D, o Cadáver Virtual 3D, conteúdos de Fisiologia, Histologia, Embriologia, Citologia, Simulação Médica e diversos outros.',
        cadaver:
          'Tenha a reconstrução 3D de um corpo humano real à disposição para dissecação virtual e complementar o ensino do laboratório de anatomia.',
        cadaver3D:
          'O Cadáver Virtual ilustra a anatomia de um corpo masculino real, com suas proporções e estruturas bem preservadas que revelam os detalhes da morfologia interna do organismo. A partir do congelamento e dissecção do corpo, todas as peças anatômicas foram fotografadas e reconstruídas em 3D a fim de facilitar a visualização e o estudo da anatomia humana.',
        atlas3D:
          'O Atlas Humano reúne as estruturas anatômicas que representam o corpo humano. A maioria das peças são similares às do corpo masculino e feminino, como nos sistemas Respiratório, Digestório, Muscular, Articular, Esquelético, Linfático e Endócrino. Já nos sistemas Urogenital, Arterial, Venoso, Nervoso e Tegumentar, algumas estruturas são diferentes, caracterizando cada sexo biológico.',
        blades:
          'Mais de 200 lâminas digitalizadas, podendo ampliar em até 40x, fazer marcações e muito mais!',
        contents1:
          'Explore o Corpo Humano em detalhes através de modelos virtuais 3D interativos',
        contents2:
          'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através a interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
        organs:
          'Aprenda sobre a anatomia humana de forma interativa através dos atlas anatômicos masculino e feminino, e por meio do cadáver virtual - uma reconstrução 3D de um corpo humano real. O estudo macroscópico do corpo humano está organizado em anatomia completa, que apresenta os sistemas e peças anatômicas de forma integrada; anatomia sistêmica e anatomia topográfica, que estudam estruturas que formam os sistemas orgânicos e regiões anatômicas.',
        cellStructure:
          'Navegue pelas células do corpo humano através de modelos interativos 3D, explorando as organelas que compõem os diferentes tipos celulares e suas funções. Além disso, um conjunto de lâminas histológicas permite ao usuário visualizar de forma microscópica diversas estruturas do corpo, como glândulas, órgãos e tecidos.',
        development:
          'Estude a fisiologia e embriologia humana através de conteúdos tridimensionais virtuais que exploram diferentes processos fisiológicos e as fases do desenvolvimento embrionário e fetal. Modelos animados possibilitam ao usuário visualizar e compreender o funcionamento do corpo humano, além de acompanhar os estágios de seu desenvolvimento - da 4ª semana de gestação até o nascimento.',
        specialties:
          'Explore o conhecimento médico de forma prática sob diferentes perspectivas. A radiologia pode ser estudada através de imagens DICOM, com ferramentas para manipulação de casos clínicos. Conheça o módulo de patologia, que utiliza modelos virtuais 3D e lâminas histológicas que permitem o estudo de diversas alterações morfológicas e funcionais do corpo humano. Além disso, acesse o simulador virtual para experimentar na prática situações de emergência na clínica médica.',
        survey:
          'Estamos te convidando a responder um pequeno formulário, é simples e rápido.',
        successShareCollection: 'Novos e-mails com acesso:',
        errorShareCollection: 'Erro nos seguintes e-mails:',
        emailsWithAccess: 'E-mails com acesso:',
        usersWithAccess: 'Usuários com acesso:',
        collectionsNotFound: 'Descubra todo o potencial das Coleções!',
        rating: 'O que acha que pode melhorar?',
        'features.collections':
          'Otimize o seu tempo com conteúdos personalizados e compartilháveis, elevando a qualidade do ensino ativo',
        'features.multiplatform':
          'Garanta acesso ilimitado em qualquer dispositivo (web, tablet, celular), impulsionando o engajamento e a flexibilidade do aluno.',
        'features.laboratory':
          'Elimine despesas com manutenção, modelos e materiais, investindo em tecnologia que valoriza o orçamento da sua instituição.',
        'features.support':
          'Ofereça recursos avançados para o desenvolvimento de estudos de caso, fortalecendo a pesquisa e a inovação na instituição.',
        'features.integration':
          'Embarque nosso conteúdo em seu site através de nossa API',
        'features.languages':
          'Conteúdo mapeado e traduzido para português, espanhol e inglês',
        histopathology:
          'Essa categoria conta com centenas de lâminas histológicas que evidenciam patologias nos tecidos e células, dos diversos sistemas e regiões anatômicas do corpo humano'
      },
      placeholders: {
        suggestion: 'Deixe seu comentário',
        optionalSuggestion: 'Deixe seu comentário (opcional)',
        email: 'Digite seu email',
        phone: 'Digite seu telefone',
        password: 'Crie sua senha',
        newPassword: 'Crie sua senha',
        token: 'Digite o código',
        name: 'Digite seu nome',
        lastName: 'Digite seu sobrenome',
        idNumber: 'Digite o CPF (apenas números)',
        search: 'Pesquisar',
        searchTerms: 'Pesquisar por termos ou títulos',
        searchQuestion: 'Qual conteúdo você deseja estudar?',
        resultsFor: 'Resultados para',
        find: 'Buscar',
        country: 'Digite seu País',
        profession: 'Digite sua profissão',
        countrySelect: 'Selecione seu País',
        professionSelect: 'Selecione sua profissão',
        institution: 'Digite sua instituição ou empresa',
        departmentSelect: 'Escolha um departamento',
        message: 'Escreva aqui sua mensagem',
        defaultCollectionTitle: 'Sem título',
        renameCollection: 'Adicione o nome para uma nova pasta ou modelo',
        moveCollection: 'Selecione a pasta que deseja mover',
        shareCollection: 'Digite o E-mail que deseja compartilhar',
        createFolder: 'Adicione o nome da nova pasta',
        newContent: 'O que há de novo'
      },
      labels: {
        email: 'Email',
        password: 'Senha',
        newPassword: 'Nova Senha',
        oldPassword: 'Senha atual',
        repeatPassword: 'Repita a senha',
        token: 'Informe o código recebido',
        firstName: 'Nome',
        lastName: 'Sobrenome',
        fullName: 'Nome completo',
        guardianName: 'Nome do Responsável',
        guardianIdNumber: 'CPF do Responsável',
        minorName: 'Nome do menor de idade',
        country: 'País',
        profession: 'Profissão',
        institution: 'Nome da Instituição ou Empresa',
        department: 'Em qual departamento deseja falar',
        isAfya: 'Sua instituição pertence ao Grupo Afya?',
        message: 'Mensagem',
        phone: 'Telefone',
        mobile: 'Telefone celular',
        language: 'Idioma',
        pt: 'Português',
        es: 'Español',
        en: 'English',
        undefined: 'Indefinido',
        description: 'Descrição',
        details: 'Detalhes',
        forbidden: 'Módulo não liberado',
        account: 'Conta',
        personalAccount: 'Conta Pessoal',
        corporateAccount: 'Conta Corporativa',
        legal: 'Jurídico',
        useTerms: 'Termos de Uso',
        politics: 'Política de Privacidade',
        cookies: 'Política de Cookies',
        requests: 'Pedidos de titular',
        dragFile: 'Arraste ou',
        uploadFile: 'faça o Upload',
        availability: 'Disponível em:',
        contactWhats: '+55 48 99958-0174',
        contactEmail: 'comercial@medicalharbour.com',
        module: 'Módulo',
        modules: 'Módulos',
        newModule: 'Novo Módulo',
        new: 'Novo',
        updated: 'Atualizado',
        newContent: 'Novos conteúdos',
        step: 'Etapa',
        renameCollection: 'Nome da pasta ou modelo',
        moveCollection: 'Mover para',
        shareCollection: 'Compartilhar Modelo ou Pasta',
        createdAt: 'Criado em',
        folderName: 'Nome da pasta',
        directLink: 'Link direto',
        options: 'Opções',
        selectFolder: 'Localização do Conteúdo',
        '3d_contents': 'Conteúdos 3D',
        slides: 'Lâminas',
        shearchFolder: 'Pesquisar pasta',
        addedAt: 'Adicionado em',
        myCollection: 'Minha Coleção',
        myCollections: 'Minhas Coleções',
        collectionsSharedWithMe: 'Compartilhados comigo',
        afyaCollections: 'Coleções Afya',
        order: 'Ordem',
        recentsOrder: 'Mais recentes',
        alphabeticalOrder: 'Alfabética',
        sortAlphabeticalAsc: 'Alfabética (A-Z)',
        sortAlphabeticalDesc: 'Alfabética (Z-A)',
        sortRelease: 'Lançamento mais recente',
        sortRelevance: 'Relevância',
        contentTypeOrder: 'Tipo',
        filter: 'Filtrar',
        type: 'Tipo',
        mostRecent: 'Mais recente',
        recentViewedContents: 'Conteúdos acessados recentemente',
        weeklyTopContents: 'Mais acessados da semana',
        nextReleasesContents: 'Próximos lançamentos',
        notifyActivated: 'Aviso ativado!',
        notifyRelease: 'Me avise no lançamento',
        filterByModule: 'Filtros por módulos'
      },
      buttons: {
        signup: 'Cadastrar',
        signin: 'Iniciar sessão',
        enter: 'Acessar',
        save: 'Salvar',
        cancel: 'Cancelar',
        return: 'Voltar',
        exit: 'Sair',
        edit: 'Editar',
        update: 'Atualizar',
        view: 'Visualizar',
        subscribe: 'Assinar',
        send: 'Enviar',
        adjust: 'Ajustar',
        remember: 'Lembre-me',
        sendData: 'Enviar Dados',
        sendToken: 'Enviar e-mail para redefinir',
        resendToken: 'Reenviar código',
        resetPassword: 'Redefinir senha',
        changePassword: 'Alterar Senha',
        changeProfile: 'Alterar Dados',
        changeLanguage: 'Alterar Idioma',
        changeAvatar: 'Alterar Foto',
        deleteAccount: 'Excluir Conta',
        confirmDelete: 'Excluir mesmo assim',
        cancelDelete: 'Não excluir',
        viewPlan: 'Conferir todos os serviços do seu Plano',
        finalizeAccount: 'Finalizar Cadastro',
        navigation: 'Noções de Navegação',
        shortcuts: 'Atalhos de Teclado',
        demo: 'Solicite uma Demonstração',
        discover: 'Quero conhecer o BioAtlas',
        openNewTab: 'Abrir em uma nova aba',
        getNews: 'Receber novidades',
        knowMore: 'Saiba mais',
        knowContent: '$t(buttons.knowMore) sobre nosso conteúdo',
        knowModules: '$t(buttons.knowMore) sobre nossos módulos',
        knowCadaver: '$t(buttons.knowMore) sobre o cadáver virtual',
        askDemo: 'Peça agora a demo para sua instituição',
        askDemoNow: 'Peça agora a demo para sua instituição',
        requestPresentation: 'Solicitar apresentação',
        surveyNo: 'Não, obrigado',
        surveyYes: 'Vamos lá!',
        seeContent: 'Visualizar conteúdo',
        keepReading: 'continuar leitura no conteúdo',
        relatedContent: 'Conteúdos Relacionados',
        bibliography: 'Bibliografia',
        share: 'Compartilhar',
        rename: 'Renomear',
        duplicate: 'Duplicar',
        move: 'Mover',
        delete: 'Excluir',
        createFolder: 'Criar pasta',
        sendFeedback: 'Enviar meu feedback',
        seeAll: 'ver todos',
        copyLink: 'Copiar Link',
        linkCopied: 'Copiado!',
        emailTab: 'E-mail',
        linkTab: 'Link',
        firstSteps: 'Primeiros passos',
        navigationAndShortcuts: 'Navegação e atalhos',
        addNewEmails: 'Add novos emails',
        close: 'Fechar',
        manageAccess: 'Gerenciar acesso',
        addToCollection: 'Add para a minha coleção',
        add: 'Adicionar',
        startNow: 'Começar agora',
        applyFilter: 'Aplicar filtro',
        accessPortal: 'Como acessar pelo portal da sua instituição',
        universityPortal: 'Como acessar pelo portal da universidade',
        continueLogin: 'Continuar tentando login',
        needHelpAccess: 'Ainda precisa de ajuda para acessar?',
        understood: 'Entendi'
      },
      institutionSelection: {
        title: 'Como acessar pelo portal da sua instituição',
        description: 'Selecione sua instituição para ver o tutorial específico',
        canvasTitle: 'Canvas ou Acesso Afya',
        canvasDescription:
          'Para instituições que utilizam Canvas ou portal Acesso Afya',
        othersTitle: 'Outras instituições',
        othersDescription: 'Para outras plataformas de ensino institucional'
      },
      institutionTutorial: {
        canvas: {
          title: 'Como acessar via Canvas ou Acesso Afya',
          steps: {
            1: 'Acesse o portal do Canvas da sua Universidade',
            2: 'Na Aba de cursos, Selecione uma opção',
            3: 'Procure BioAtlas nas opções listadas',
            4: 'Agora basta clicar em acessar BioAtlas',
            5: 'O BioAtlas abrirá automaticamente em seu navegador'
          }
        },
        other: {
          title: 'Como acessar via plataforma de ensino da sua instituição',
          steps: {
            1: 'Acesse a plataforma de ensino da sua Universidade',
            2: 'Procure BioAtlas nas opções listadas',
            3: 'Agora basta clicar em acessar BioAtlas',
            4: 'O BioAtlas abrirá automaticamente em seu navegador'
          }
        }
      },
      separators: {
        or: 'Ou'
      },
      messages: {
        conjunction: 'e',
        separator: 'ou',
        optional: 'opcional',
        agreeTerms1: 'Ao me cadastrar, eu concordo que li e aceito os',
        agreeTerms2: 'Eu concordo que li e aceito os',
        agreeTermsMinorS:
          'Sou maior de 18 anos e estou ciente das responsabilidades.',
        agreeTermsMinorL:
          'Sou menor de 18 anos e meu responsável legal autoriza a Medical Harbour a coletar meus dados pessoais para fins de comunicações eletrônicas de ofertas e serviços (SMS, mensagens instantâneas, telefone, e-mail) de acordo com a $t(labels.politics).',
        validationSent: 'Enviamos um email para você validar seu cadastro!',
        contactAdmin:
          'Por favor, entre em contato com o Administrador do seu sistema!',
        accountReady: 'Seu acesso ao BioAtlas está ativo!',
        dataSharing:
          'Aceitar o compartilhamento de dados para ofertas de produtos',
        notifications:
          'Aceitar receber notificações pelo SMS, Whatsapp ou email?',
        deleteQuestion:
          'Tem certeza de que deseja deletar permanentemente sua conta?',
        deleteReminder1:
          'Excluir sua conta BioAtlas é uma ação permanente e não pode ser desfeita.',
        deleteReminder2:
          'Depois de excluir sua conta, você não poderá fazer login novamente no aplicativo e quaisquer modelos 3D que você criou e salvou em sua Biblioteca serão removidos de nosso banco de dados permanentemente e não podem ser restaurados.',
        trialWarning:
          'Você está usando a versão trial. Ainda falta {{count}} dia.',
        trialWarning_plural:
          'Você está usando a versão trial. Ainda faltam {{count}} dias.',
        trialUpgrade: 'Obter versão PRÓ.',
        noContent: 'Sem resultados para',
        newContent: 'Novos conteúdos que podem te interessar',
        noAccount: 'Você ainda não possui uma conta?',
        gotAccount: 'Você já possui uma conta?',
        passwordsDontMatch: 'Senhas precisam ser iguais!',
        notYetValidated:
          'Você ainda não validou seu cadastro pelo email que foi enviado!',
        notYetConfirmed:
          'Você ainda não confirmou seu cadastro. Verifique seu email.',
        confirmAccount: 'Confirme sua conta BioAtlas',
        notYetConfirmed1: 'Antes de alterar sua senha,',
        notYetConfirmed2: 'Antes de fazer login,',
        notYetConfirmed3: 'confirme sua conta no e-mail.',
        notYetConfirmed4:
          'Não esqueça de verificar também a caixa de spam, ok?',
        checkData: 'Verifique seus dados e tente novamente',
        loginInvalid: 'Usuário e/ou senha inválidos',
        userNotFound: 'Usuário não encontrado',
        userNotFoundInstitutional:
          'Não conseguiu entrar? Você pode estar tentando acessar com uma conta institucional.',
        wrongPassword: 'Senha atual está incorreta',
        tooManyRequests:
          'Você realizou muitas requisições. Aguarde um momento e tente novamente.',
        tooManyFailedAttempts: 'Você falhou em várias tentativas',
        tooManyAttempts: 'Você excedeu o limite de tentativas',
        tokenSent: 'Código enviado para o email: {{email}}',
        passwordChanged: 'Senha alterada com sucesso!',
        tokenInvalid:
          'Código fornecido inválido. Solicite um código novamente.',
        passwordTooShort: 'Sua senha deve conter 8 caracteres',
        tryAgain:
          'Houve um problema ao enviar suas informações. Tente novamente!',
        partialSuccessData:
          'Seus dados foram atualizados com sucesso, porém, houve um problema ao enviar sua foto.',
        partialSuccessImg:
          'Sua foto foi atualizada com sucesso, porém, houve um problema ao enviar seus dados.',
        requiredField: 'Campo obrigatório',
        invalidEmail: 'Informe um email válido',
        emailExists: 'Já existe uma conta com o email fornecido',
        phoneExists: 'Este número de telefone já está registrado',
        phoneTooShort: 'Número de telefone inválido.',
        idTooShort: 'Número de CPF inválido.',
        dataUpdated: 'Dados atualizados com sucesso!',
        collectionDeleted: 'Coleção excluída com sucesso!',
        alreadySignedUp:
          'Você já efetuou seu cadastro, acesse com seu login e senha!',
        invalidLink:
          'Este link não é válido, por favor entre em contato com o seu administrador!',
        multipleImages: 'Envie somente um arquivo',
        imageType:
          'Esse tipo de arquivo não é suportado. Extensões válidas: {{support}}',
        imageSize:
          'O arquivo é muito grande! ({{size}}) O tamanho máximo para upload é {{limit}}.',
        agreement:
          'Você precisa aceitar os $t(labels.useTerms) e a $t(labels.politics)',
        guardianData:
          'Por ser menor de idade, você precisa inserir os $t(titles.guardianData)',
        unreachable:
          'Nosso servidor está passando por dificuldades técnicas. Tente novamente mais tarde.',
        accessDenied: 'Por favor, realize seu login novamente.',
        unverifiedEmail: 'Erro: email não verificado',
        autoLogin: 'Estamos realizando seu login.',
        copySuccess: 'Copiado para a área de transferência!',
        copyError: 'Erro ao copiar!',
        unexistingModule: 'Conteúdo não existe',
        unavailable: 'Conteúdo não disponível',
        betterExp:
          'Para ter uma melhor experiência, acesse pelo nosso aplicativo ou Desktop',
        desktop: 'Desktop',
        appAvailable: 'Faça o download do aplicativo BioAtlas nas lojas',
        support1: 'Por favor, entre em contato com nossa',
        support2: 'equipe de suporte',
        crash: 'Algo deu errado com o BioAtlas. $t(messages.support1)',
        appDenied:
          'Vimos que você não possui acesso ao BioAtlas. $t(messages.support1)',
        contactSuccess1: 'Olá! Acabamos de receber sua mensagem!',
        contactSuccess2:
          'Ficamos super felizes em saber que você quer conversar com a gente. Agradecemos muito pelo seu interesse pelo BioAtlas.',
        contactSuccess3:
          'Estamos analisando sua mensagem e logo entraremos em contato para responder às suas perguntas e comentários.',
        whichContents: 'Quais capítulos você irá acessar:',
        errorCollection:
          'Desculpe, houve um erro ao tentar acessar suas coleções',
        emptyCollections:
          'Parece que ainda não tem nenhuma coleção. Escolha qualquer modelo 3D, personalize do seu jeito e salve ;)',
        emptyCollectionsMobile:
          'Parece que ainda não tem nenhuma coleção. Acesse seu aplicativo para visualizar suas coleções.',
        emptyCollectionsShared:
          'Nenhuma coleção foi compartilhada com você ainda. Quando alguém compartilhar, elas aparecerão aqui.',
        collectionRenamed: 'Coleção renomeada com sucesso!',
        folderRenamed: 'Pasta renomeada com sucesso!',
        collectionMoved: 'Coleção movida com sucesso!',
        collecionDeleted: 'Coleção deletada com sucesso!',
        collecionShared: 'Coleção compartilhada com sucesso!',
        collectionUnshared: 'Usuário removido do compartilhamento com sucesso!',
        collectionDuplicated: 'Coleção duplicada com sucesso!',
        collectionFolderCreated: 'Pasta criada com sucesso!',
        collectionFolderDuplicateErr: 'Pasta com esse nome já existe',
        demoPopUpText1: 'Você possui ',
        demoPopUpTextDays: 'dia ',
        demoPopUpTextDaysPlural: 'dias ',
        demoPopUpTextMonths: 'mês ',
        demoPopUpTextMonthsPlural: 'meses ',
        demoPopUpText2: ' de acesso demonstração',
        demoPopUpText3:
          ', sua opinião sobre nossa plataforma é muito importante.',
        demoExpiredText:
          'A sua licença de demonstração expirou. Por favor, entre em contato com o nosso suporte.',
        demoExpiredBtn: 'Conversar com nossa equipe',
        errorInputShared:
          'Não é possível compartilhar a coleção com esse email',
        by: 'Por',
        deleteCollectionMsgSingular:
          'Ao excluir essa Pasta o seguinte modelo ou pasta também irá ser deletado:',
        deleteCollectionMsgPlural:
          'Ao excluir essa Pasta os seguintes modelos ou pastas também irão ser deletados:',
        folderNotFound: 'Pasta não encontrada',
        newContentTitle: 'Confira as novidades do BioAtlas',
        newContentSubtitle: 'Nova ferramenta para salvar suas coleções',
        newContentText:
          'Agora você pode criar uma coleção personalizada de conteúdos 3D. Com o BioAtlas, é possível salvar esses modelos, organizá-los em pastas e compartilhá-los de forma simples e rápida com seus amigos e alunos.',
        newContentClose: 'Fechar',
        to: 'para',
        thankYouRating: 'Obrigado pela sua avaliação',
        pickRateError:
          'Por favor, escolha uma nota para este conteúdo ou altere sua nota/sugestão anterior antes de enviar',
        shareCollectionErrorTitle: 'Erro ao obter coleção',
        shareCollectionErrorText:
          'Não foi possível acessar a coleção que foi compartilhada com você. Você será redirecionado para a página inicial',
        expiredCollectionLinkErrorTitle: 'Link expirado',
        expiredCollectionLinkErrorText:
          'Obtenha um novo link para ter acesso a essa coleção. Você será redirecionado para a página inicial',
        clipboardPermissionsErrorTitle: 'Não foi possível copiar o link',
        clipboardPermissionsErrorText:
          'Verifique as permissões do site em relação a área de transferência e tente novamente',
        saveCollectionSuccessTitle: 'Conteúdo adicionado',
        saveCollectionSuccessText:
          'O conteúdo foi adicionado à sua coleção com sucesso',
        saveCollectionErrorTitle: 'Erro ao salvar conteúdo nas coleções',
        saveCollectionErrorText:
          'Não foi possível salvar o conteúdo no momento. Tente novamente mais tarde',
        lockedItem: 'Conteúdo institucional bloqueado',
        lockedFolderNoCreate:
          'Você não pode criar pastas dentro de coleções institucionais.',
        notFoundContentForTerm: 'Nenhum conteúdo foi encontrado para o termo',
        trySimilarTerms:
          'Tente usar palavras semelhantes ou verificar a ortografia.',
        relatedContentsTerm: 'Conteúdos relacionados ao termo'
      },
      swal: {
        success: 'Sucesso',
        warning: 'Atenção',
        error: 'Um problema ocorreu!',
        access: 'Você não possui acesso',
        crash: 'Opps!!!'
      },
      banner: {
        title: 'Você Sabia?',
        curiosity1:
          'O encéfalo humano tem, aproximadamente, 86 bilhões de neurônios. Apenas 19% deles estão localizados no córtex cerebral, enquanto o cerebelo contém cerca de 80%. O restante está localizado no tronco encefálico.',
        curiosity2:
          'O corpo humano brilha no escuro. Esse processo consiste na emissão de biofótons, caracterizado por reações químicas que emitem pequenas quantidades de luz nas nossas células. Não percebemos esse brilho a olho nu pois a intensidade é muito mais fraca do que podemos detectar.'
      },
      alts: {
        load: 'Animação de carregamento',
        logo: 'Logo do BioAtlas',
        eye: 'Ícone de olho para habilitar visibilidade da senha',
        avatar: 'Foto de perfil do usuário',
        edit: 'Ícone de edição',
        computer: 'Imagem de um computador alertando que chegou um email',
        check: 'Animação de um ícone de check',
        folder: 'Pasta',
        home: 'Casa',
        playstore: 'Imagem playstore',
        appstore: 'Imagem appstore'
      },
      modules: {
        cytology: 'Citologia',
        transports: 'Transportes de Membrana',
        histology: 'Histologia',
        systemicAnatomy: 'Anatomia Sistêmica',
        topographicAnatomy: 'Anatomia Topográfica',
        completeAnatomy: 'Anatomia Completa',
        physiology: 'Fisiologia',
        embryology: 'Embriologia',
        radiology: 'Radiologia',
        pathology: 'Patologia',
        histopathology: 'Histopatologia'
      },
      categories: {
        all: 'Todos',
        tissues: 'Tecidos',
        systems: 'Sistemas',
        organs: 'Órgãos Sensoriais',
        atlas: 'Atlas Humano',
        atlas2: 'Atlas Anatômico',
        cadaver: 'Cadáver Virtual'
      },
      improvements: {
        exam_quality: 'Qualidade do exame',
        exam_report: 'Laudo do exame',
        features: 'Funcionalidades',
        usability_navigation: 'Usabilidade/Navegação',
        other_reason: 'Outro motivo (comente abaixo)',
        text: 'Texto',
        slide_quality: 'Qualidade da lâmina',
        information_consistency: 'Coerência das informações',
        sample: 'Amostra',
        structure_identification: 'Identificação das estruturas',
        morphology: 'Morfologia',
        loading: 'Carregamento',
        content_depth: 'Aprofundamento de conteúdo'
      },
      subCategories: {
        epithelial: 'Tecido Epitelial',
        connective: 'Tecido Conjuntivo',
        circulatory: 'Circulatório',
        articular: 'Articular',
        digestive: 'Digestório',
        endocrine: 'Endócrino',
        skeletal: 'Esquelético',
        integumentary: 'Tegumentar',
        lymphoid: 'Linfático',
        muscular: 'Muscular',
        nervous: 'Nervoso',
        respiratory: 'Respiratório',
        urogenital: 'Urogenital',
        male: 'Masculino',
        female: 'Feminino'
      },
      helpers: {
        rotateMouse:
          'Segure o botão esquerdo do mouse e mova para rotacionar o objeto',
        moveMouseBlade:
          'Segure o botão esquerdo do mouse e arraste para mover a lâmina',
        moveMouseModel:
          'Segure o botão direito do mouse para mover o objeto na tela',
        selectMouse:
          'Clique uma vez com o botão esquerdo para selecionar uma estrutura',
        zoomMouse:
          'Utilize o botão scroll do mouse para aumentar ou diminuir zoom',
        textboxMouse:
          'Pressione o botão Shift no teclado, pressione o botão esquerdo do mouse e arraste',
        cameraKeyboard:
          'Utilize a tecla (W) para mover para cima, tecla (S) para mover para baixo, tecla (A) para mover para esquerda e tecla (D) para mover para direita',
        rotateKeyboard:
          'Utilize a tecla (↑) para rotacionar para cima, (↓) para rotacionar para baixo, (←) para rotacionar para a esquerda e (→) para rotacionar para a direita',
        zoomKeyboard: 'Utilize as teclas de + e - para aplicar o zoom',
        moveKeyboard: 'Utilize as setas para movimentar a lâmina',
        rotatePad: 'Segure o botão esquerdo do trackpad e mova para rotacionar',
        movePad:
          'Segure o botão direito do trackpad e movimente a câmera do objeto',
        zoomPad:
          'Clique uma vez com o botão esquerdo para selecionar uma estrutura'
      },
      home: {
        banner: {
          title: 'Conteúdo Virtual Interativo 3D para Ensino na Área da Saúde',
          subtitle:
            'Explore conteúdos digitais interativos 3D para Ensino do Ciclo Básico em Saúde através de um navegador web, aplicativo Android/iOS e óculos de Realidade Virtual'
        },
        specs: {
          title:
            'Navegue através dos detalhes do Corpo Humano a qualquer hora, em qualquer lugar!',
          item1: 'Acesso Multiplataforma',
          text1:
            'Acesse através de qualquer navegador web, aplicativo Android ou iOS, sem necessidade de plugins, não requer instalação',
          item2: 'Controle de Acesso',
          text2:
            'Habilite, controle e análise os acessos de professores e alunos',
          item3: 'Disponível em 3 línguas',
          text3:
            'Conteúdo mapeado e traduzido para português, espanhol e inglês',
          item4: 'Integração',
          text4: 'Embarque nosso conteúdo em seu site através de nossa API',
          item5: 'Animações Interativas 3D',
          text5:
            'Diversos conteúdos com animações 3D guiadas para fácil compreensão',
          item6: 'Realidade Virtual 3D',
          text6:
            'Envolva alunos e professores através do ambiente imersivo da Realidade Virtual'
        },
        minibanner: 'Reduza os custos do laboratório de Anatomia',
        allInOne: {
          title:
            'Uma suíte multiplataforma para acesso a uma Biblioteca Digital Interativa de conteúdos 3D para Ensino em Saúde',
          text: 'O BioAtlas é uma solução que se adapta diversas ferramentas tecnológicas do mercado e permite navegar através de Conteúdos Digitais Interativos 3D para saúde utilizando qualquer navegador web ou app mobile Android ou iOS e Óculos de Realidade Virtual'
        },
        teaser: 'Conheça um pouco mais sobre o BioAtlas',
        dashboard: {
          title:
            'Dashboard com dados para acompanhamento de indicadores de uso',
          subtitle:
            'Mais inteligência para acompanhamento de uso do sistema e resultados a seu favor',
          text1:
            'Analise o uso, engajamento, performance e outras métricas importantes para melhorar o aprendizado',
          text2: 'Obtenha insights das interações dos usuários'
        },
        quotes: {
          text1:
            'O BioAtlas é uma excelente ferramenta para que o aluno integre os diferentes conteúdos das ciências biológicas e da saúde',
          position: 'Professor de Fisiologia Humana e Neurociências na FMIT'
        },
        carousel: {
          startHere: {
            title: 'Não sabe por onde começar?',
            description:
              'As coleções Afya possuem conteúdos selecionados e organizados para você.',
            button: 'Acessar coleções Afya'
          },
          collections: {
            title:
              'Quer compartilhar seus estudos personalizados de forma simples e organizada?',
            description: 'Crie uma coleção e compartilhe com quem quiser!',
            button: 'Acessar coleções'
          },
          suggestions: {
            title: 'Não encontrou o que precisava?',
            description:
              'Sua sugestão pode inspirar os próximos conteúdos da plataforma.',
            button: 'Vamos lá!'
          }
        },
        conclusion:
          'Conheça o BioAtlas, suas possibilidades, e garanta o conhecimento em Saúde de sua Instituição em qualquer cenário de aprendizado.',
        'footerBannerSubtitle.1': 'O BioAtlas também está no seu bolso.',
        'footerBannerSubtitle.2': 'Baixe o app e leve seus estudos com você!'
      },
      contentTypes: {
        unity: 'Conteúdos 3D',
        slide: 'Lâminas',
        dicom: 'Imagens'
      },
      contents: {
        banner: {
          title:
            'Explore o Corpo Humano em detalhes através de modelos virtuais 3D interativos',
          subtitle:
            'O BioAtlas permite navegar através do corpo humano de maneira virtual totalmente interativa utilizando qualquer navegador web, smartphone ou óculos de Realidade Virtual.',
          obs: '*Está disponível em 3 línguas: Português, Inglês e Espanhol'
        },
        systems: {
          title: 'Sistemas do corpo humano',
          completeAnatomy: {
            text1:
              'conta com mais de 2500 estruturas de todos os sistemas anatômicos do corpo humano etiquetados. Este módulo está separado em modelo Masculino e Feminino e organizado de acordo com 12 sistemas anatômicos e 9 regiões.',
            text2:
              'é a reconstrução 3D de um corpo humano real que foi doado para pesquisa*. Foi congelado, dividido em 1878 fatias e fotografado com equipamentos de altíssima resolução. O Cadáver Virtual possui as cores preservadas, está segmentado e mapeado para visualização completa.',
            obs1: '*A versão 3D em Realidade Virtual - VR - é uma forma imersiva para o entendimento e a compreensão do corpo humano a um passo do metaverso.',
            obs2: '*Saiba mais sobre o Projeto Visible Human'
          },
          topographicAnatomy: {
            text: 'Navegue nos Elementos Descritivos do Crânio e pelas regiões anatômicas: cabeça e pescoço, membro superior direito, membro superior esquerdo, dorso, tórax, abdome, pelve, membro inferior direito e membro inferior esquerdo.'
          },
          systemicAnatomy: {
            text: 'Sistemas Anatômicos: tegumentar, muscular, esquelético, articular, nervoso, linfático, digestório, respiratório, arterial, venoso, endócrino e urogenital.'
          },
          physiology: {
            text: 'Explore o funcionamento e as funções normais do corpo humano, através de conteúdos virtuais 3D interativos:',
            item1: 'Ciclo Cardíaco do Coração',
            item2: 'Contração da Fibra Muscular',
            item3: 'Geração e Condução de Potencial de Ação',
            item4: 'Hematose',
            item5: 'Transmissão Sináptica',
            item6: 'Ventilação Pulmonar'
          }
        },
        cellStructure: {
          title: 'Estrutura celular e microanatomia',
          cytology: {
            title: 'Citologia 3D',
            text: 'O módulo de Citologia permite ao usuário interagir com duas categorias de conteúdos 3D: Células e Membrana Celular. Navegue nas células: Célula Eucarionte de origem animal, Célula Sanguínea, Neurônio e Fibra Muscular. Visualize um modelo de Membrana Celular em 3D e cinco animações relacionadas ao transporte de moléculas pela membrana:',
            item1: 'Difusão simples',
            item2: 'Difusão facilitada',
            item3: 'Bomba de sódio e potássio',
            item4: 'Co-transporte',
            item5: 'Contra-transporte'
          },
          histology: {
            text: 'O BioAtlas possui um módulo dedicado ao estudo de lâminas de glândulas, órgãos, tecidos e sistemas, e lâminas com patologias. Além de possuir uma ferramenta com recrusos para visualização e análise das mesmas.'
          }
        },
        development: {
          title: 'Desenvolvimento humano',
          embryology: {
            text: 'Acompanhe o desenvolvimento embrionário e fetal, a partir da 4ª semana de gestação até o nascimento, através de animações interativas 3D.'
          }
        },
        specialties: {
          title: 'Especialidades médicas',
          radiology: {
            text: 'Sistema para visualização de imagens DICOM com ferramentas para manipulação de estudos e casos clínicos radiológicos. Permite visualizar imagens de diversas modalidades como Tomografias Computadorizadas, Ressonâncias Magnéticas, Raio-X, entre outras através do navegador web.'
          }
        },
        collections: {
          notFound:
            'Assista ao vídeo abaixo e veja, na prática, como cada funcionalidade pode transformar sua forma de estudar e explorar os conteúdos.'
        },
        conclusion: 'Entre em contato para conhecer o BioAtlas'
      },
      onboarding: {
        steps: {
          step1:
            'Passo 1: Queremos te conhecer melhor! Com qual área da saúde você mais se identifica?',
          step2: 'Passo 2: Especialidade ou Interesse Principal',
          step3: 'Passo 3: Momento na Carreira ou Formação',
          step4: 'Passo 4: Objetivo Principal no BioAtlas',
          step5: 'Passo 5: Preferência de Aprendizado',
          step6: 'Passo 6: Tempo Semanal Disponível'
        },
        auxiliaryTexts: {
          step1: 'Escolha apenas uma área.',
          step2:
            'Qual é sua especialidade ou área de interesse? (Se não tiver, pode escolher "Interesse geral")',
          step3: 'Em que fase da sua jornada você está?',
          step4: 'O que você busca na plataforma?',
          step5: 'Como você prefere aprender?',
          step6: 'Quanto tempo você dedica aos estudos por semana?'
        },
        buttons: {
          skip: 'Ignorar e fazer depois',
          continue: 'Continuar',
          finish: 'Finalizar e acessar BioAtlas',
          back: 'Voltar'
        },
        stepBar: {
          of: '{{step}} de {{totalSteps}}'
        },
        healthAreas: {
          medicine: 'Medicina',
          nursing: 'Enfermagem',
          pharmacy: 'Farmácia',
          physiotherapy: 'Fisioterapia',
          nutrition: 'Nutrição',
          biomedicine: 'Biomedicina',
          dentistry: 'Odontologia',
          physical_education: 'Educação Física',
          others: 'Outros'
        },
        specialties: {
          medicine: {
            clinical_medicine: 'Clínica Médica',
            pediatrics: 'Pediatria',
            general_surgery: 'Cirurgia Geral',
            gynecology_obstetrics: 'Ginecologia / Obstetrícia',
            cardiology: 'Cardiologia',
            orthopedics: 'Ortopedia',
            dermatology: 'Dermatologia',
            emergency: 'Emergência',
            geriatrics: 'Geriatria',
            ophthalmology: 'Oftalmologia',
            pathology: 'Patologia',
            general_interest: 'Interesse Geral',
            others: 'Outros'
          },
          nursing: {
            medical_surgical_nursing: 'Enfermagem Médico-Cirúrgica',
            pediatric_nursing: 'Enfermagem Pediátrica',
            obstetric_nursing: 'Enfermagem Obstétrica',
            mental_health_nursing: 'Enfermagem em Saúde Mental',
            emergency_nursing: 'Enfermagem de Emergência',
            geriatric_nursing: 'Enfermagem Geriátrica',
            public_health_nursing: 'Enfermagem em Saúde Pública',
            occupational_nursing: 'Enfermagem do Trabalho',
            others: 'Outros'
          },
          pharmacy: {
            hospital_pharmacy: 'Farmácia Hospitalar',
            clinical_pharmacy: 'Farmácia Clínica',
            clinical_analysis: 'Análises Clínicas',
            pharmaceutical_industry: 'Indústria Farmacêutica',
            community_pharmacy: 'Farmácia Comunitária',
            compounding_pharmacy: 'Farmácia de Manipulação',
            toxicology: 'Toxicologia',
            pharmacovigilance: 'Farmacovigilância',
            cosmetology: 'Cosmetologia',
            others: 'Outros'
          },
          physiotherapy: {
            neurological_physiotherapy: 'Fisioterapia Neurológica',
            respiratory_physiotherapy: 'Fisioterapia Respiratória',
            cardiovascular_physiotherapy: 'Fisioterapia Cardiovascular',
            dermatofunctional_physiotherapy: 'Fisioterapia Dermato-funcional',
            geriatric_physiotherapy: 'Fisioterapia Geriátrica',
            pediatric_physiotherapy: 'Fisioterapia Pediátrica',
            women_health_physiotherapy: 'Fisioterapia em Saúde da Mulher',
            sports_physiotherapy: 'Fisioterapia Esportiva',
            others: 'Outros'
          },
          nutrition: {
            clinical_nutrition: 'Nutrição Clínica',
            sports_nutrition: 'Nutrição Esportiva',
            public_health_nutrition: 'Nutrição em Saúde Pública',
            maternal_child_nutrition: 'Nutrição Materno-Infantil',
            geriatric_nutrition: 'Nutrição Geriátrica',
            hospital_nutrition: 'Nutrição Hospitalar',
            others: 'Outros'
          },
          biomedicine: {
            clinical_analysis: 'Análises Clínicas',
            molecular_biology: 'Biologia Molecular',
            radiology_diagnostic_imaging: 'Radiologia / Diagnóstico por Imagem',
            microbiology: 'Microbiologia',
            immunology: 'Imunologia',
            hematology: 'Hematologia',
            blood_bank_hemotherapy: 'Banco de Sangue / Hemoterapia',
            genetics: 'Genética',
            parasitology: 'Parasitologia',
            aesthetics: 'Estética',
            others: 'Outros'
          },
          dentistry: {
            dental_aesthetics_restorative:
              'Odontologia Estética / Restauradora',
            endodontics: 'Endodontia',
            periodontics: 'Periodontia',
            oral_maxillofacial_surgery: 'Cirurgia Bucomaxilofacial',
            orthodontics: 'Ortodontia',
            pediatric_dentistry: 'Odontopediatria',
            dental_prosthetics: 'Prótese Dentária',
            dental_radiology: 'Radiologia Odontológica',
            oral_pathology: 'Patologia Bucal',
            others: 'Outros'
          },
          physical_education: {
            school_physical_education: 'Educação Física Escolar',
            sports_training: 'Treinamento Esportivo',
            physical_activity_health: 'Atividade Física e Saúde',
            recreation_leisure: 'Recreação e Lazer',
            bodybuilding_conditioning: 'Musculação / Condicionamento',
            rehabilitation_therapeutic_exercise:
              'Reabilitação / Exercício Terapêutico',
            workplace_gymnastics: 'Ginástica Laboral',
            psychomotricity: 'Psicomotricidade',
            special_populations_physical_activity:
              'Atividade Física para Populações Especiais',
            others: 'Outros'
          },
          others: {
            general_interest: 'Interesse Geral',
            others: 'Outros'
          }
        },
        academicLevels: {
          student: 'Estudante de graduação',
          resident: 'Residente / Pós-graduando',
          professor: 'Professor / Pesquisador'
        },
        semesters: {
          '1-2': '1º - 2º semestre',
          '3-4': '3º - 4º semestre',
          '5-6': '5º - 6º semestre',
          '7+': '7º+ semestre'
        },
        objectives: {
          study: 'Acompanhar matérias da faculdade',
          pass_exams: 'Passar em prova (residência, concurso)',
          practical: 'Aprender habilidades práticas',
          personal_interest: 'Explorar novos conteúdos por interesse pessoal'
        },
        learningPreferences: {
          videos: 'Videos',
          summaries: 'Resumos organizados',
          articles: 'Artigos',
          clinical_cases: 'Casos clínicos e exercícios',
          audios: 'Podcasts e áudio-aulas',
          study_group: 'Grupos de estudo e fóruns'
        },
        weeklyTime: {
          '3h': 'Pouco tempo (Até 3h/semana)',
          '4-7h': 'Algumas horas (4 a 7h/semana)',
          '8h': 'Muito tempo (8h ou mais)'
        },
        subtexts: {
          healthAreaOthers:
            'Quer explorar outras áreas da saúde? Escreva aqui suas preferências!',
          specialtyOthers:
            'Quer explorar outras especialidades? Escreva aqui suas preferências!',
          semesterTitle: 'Ano/Semestre:'
        },
        tempContent: {
          stepContent: 'Conteúdo da {stepText}',
          tempArea:
            'Esta é uma área temporária para o conteúdo específico de cada etapa.'
        },
        editBanner: {
          title: 'Que tal completar seu perfil?',
          subtitle:
            'Com isso, entendemos melhor os seus interesses e preferências.',
          editProfile: 'Editar meu perfil',
          letsGo: 'Vamos lá'
        }
      },
      integration: {
        banner: {
          title: 'Adicione a interatividade 3D do BioAtlas a seu conteúdo',
          subtitle:
            'Dê vida ao seu projeto da área da saúde adicionando sua marca ao BioAtlas ou embarcando nossas animações, peças virtuais interativas através da integração BioAtlas API.'
        },
        api: {
          label: 'API BioAtlas',
          title:
            'O conteúdo 3D do BioAtlas em seu projeto através de nossa API',
          subtitle:
            'Construa uma experiência interativa virtual 3D em seu projeto relacionado à anatomia ou outras disciplinas relacionadas ao ciclo básico em Saúde. O conteúdo do BioAtlas pode ser facilmente integrável a seu website, conteúdo digital, LMS ou projeto digital através da BioAtlas API.'
        },
        institutions: {
          label: 'Instituições',
          title: 'BioAtlas para sua instituição',
          item1: 'Farmacêutica',
          item2: 'Universidades',
          item3: 'Hospitais',
          item4: 'Editoras'
        },
        whiteLabel: {
          label: 'White Label',
          title: 'BioAtlas com a marca da sua Instituição',
          subtitle:
            'O BioAtlas possui uma solução “Private Label”, que permite uma colocar marca da sua Instituição tornando uma solução 100% customizada.'
        }
      },
      contactPage: {
        form: {
          step: 'Etapa',
          of: 'de',
          select: 'Selecione',
          title: 'Solicite agora sua demonstração gratuita do BioAtlas',
          previousButton: 'Voltar',
          nextButton: 'Avançar',
          submitButton: 'Concluir solicitação',
          businessEmail: 'Digite seu email comercial',
          allowReceiveEmails:
            'Estou de acordo em receber novidades no meu e-mail.',
          fullName: 'Ótimo! Agora, digite seu nome completo.',
          phone: 'Muito bem! Agora, digite seu número de telefone / WhatsApp.',
          institutionName: 'Qual o nome da sua instituição?',
          profession: 'Qual o seu cargo ou profissão?',
          professions: {
            coordinator: 'Coordenador(a) de Curso',
            professor: 'Professor(a)',
            student: 'Aluno(a)',
            others: 'Outros'
          },
          privacyPolicy: {
            text: 'Ao enviar meus dados pessoais, autorizo o BioAtlas a coletar, processar e armazenar minhas informações de acordo com o Aviso de Privacidade, conforme descrito em ',
            link: 'Aviso de privacidade do BioAtlas.'
          },
          success: {
            header: 'Sua solicitação de demonstração foi enviada com sucesso!',
            label:
              'Em breve, entraremos em contato para agendar uma demonstração do BioAtlas.'
          },
          error: {
            header: 'Ocorreu um erro ao enviar suas informações.',
            label: 'Por favor, tente novamente mais tarde.'
          }
        },
        contentSuggestion: {
          title: 'Qual conteúdo você gostaria de estudar no BioAtlas?',
          moduleLabel: 'Em qual módulo do BioAtlas esse conteúdo se encaixa?',
          modulePlaceholder: 'Selecione o módulo',
          titleLabel: 'Título ou tema do conteúdo',
          titlePlaceholder:
            'Ex: Embriologia do coração, Casos clínicos de trauma',
          detailsLabel: 'Detalhes adicionais (opcional)',
          detailsPlaceholder:
            'Descreva o que gostaria de ver ou como esse conteúdo pode ajudar',
          submitting: 'Enviando...',
          submit: 'Enviar sugestão',
          successMessage:
            'Sua sugestão foi enviada com sucesso! Obrigado por contribuir com o BioAtlas.'
        }
      },
      landingV2: {
        heroBanner: {
          title: 'Um ecossistema de ferramentas para educação em saúde',
          subtitle:
            'O BioAtlas contribui para o aperfeiçoamento do trabalho docente e o processo de aprendizado discente.',
          button: 'Solicitar apresentação',
          note: '*O BioAtlas é exclusivo para Instituições de Ensino'
        },
        sectionAppBioAtlas: {
          title:
            'O BioAtlas também possui um aplicativo exclusivo para os usuários da sua instituição',
          downloadText: 'Disponível para download em',
          button: 'Conhecer mais sobre o App'
        },
        sectionCtaBioAtlas: {
          text: 'Descubra como o BioAtlas transforma o ensino.<br/>Solicite uma apresentação gratuita e explore essa<br/>inovação em ação!',
          button: 'Solicitar apresentação'
        },
        sectionCtaCytology: {
          text: 'Eleve o ensino e a aprendizagem de Medicina<br/>com o BioAtlas.',
          button: 'Solicitar apresentação'
        },
        sectionEnriquecaAulas: {
          title: 'Enriqueça suas aulas de saúde humana com nosso conteúdo',
          blocks: {
            visualizacao: {
              title: 'Visualização Interativa em 3D',
              text: 'Reconhecemos que o aprendizado eficaz sobre o corpo humano e suas complexidades exige mais do que a simples memorização de termos. Para melhorar a compreensão do ensino de saúde humana, o BioAtlas oferece uma abordagem inovadora e imersiva.'
            },
            integracao: {
              title: 'Integração',
              text: 'Realize cortes e salve seções específicas no conteúdo disponível, delimitando as informações de interesse conforme suas necessidades de pesquisa ou estudo.'
            },
            customizacao: {
              title: 'Visualização Customizada',
              text: 'É possível realizar cortes, seções e salvar o conteúdo customizado nas coleções.'
            }
          }
        },
        sectionEstudanteProfissional: {
          title: 'Do estudante ao profissional',
          subtitle: 'uma solução completa para ensino em saúde',
          bullets: {
            otimizacao: {
              title: 'Otimização de custos - ',
              text: 'Redução de despesas significativas com a manutenção de laboratórios, peças anatômicas e estruturas físicas complexas.'
            },
            potencializacao: {
              title: 'Potencialização de Resultados - ',
              text: 'O BioAtlas aprimora a aprendizagem, o engajamento, a retenção discente e o desempenho em avaliações, incluindo as do Ministério da Educação (MEC)'
            },
            recurso: {
              title: 'Recurso Pedagógico Essencial - ',
              text: 'Um recurso didático que suporta metodologias ativas, compartilhamento de coleções e preparação prática para o ensino diário.'
            },
            praticidade: {
              title: 'Praticidade - ',
              text: 'Facilita o trabalho docente, centralizando todos os recursos em uma única ferramenta.'
            },
            disponivel: {
              title: 'Disponível onde estiver - ',
              text: 'Conteúdo multiplataforma, disponível em ambientes web e mobile, permitindo downloads e estudo dentro e fora do ambiente de sala de aula.'
            }
          }
        },
        sectionModulosBioAtlas: {
          title:
            'Conheça nossos módulos para um estudo aprofundado completo do corpo humano',
          fallbackText: 'Imagem em breve',
          knowMore: 'Saber mais',
          modules: {
            histologia: 'Histologia',
            patologia: 'Patologia',
            histopatologia: 'Histopatologia',
            radiologia: 'Radiologia',
            fisiologia: 'Fisiologia',
            embriologia: 'Embriologia',
            citologia: 'Citologia',
            anatomiaTopografica: 'Anatomia Topográfica',
            anatomiaSistemica: 'Anatomia Sistêmica',
            anatomiaCompleta: 'Anatomia Completa'
          }
        },
        sectionResults: {
          title: 'Resultados que fazem a diferença',
          cards: {
            alunos: { text1: 'Utilizado por mais de', text3: 'alunos' },
            instituicoes: {
              text1: 'Presente em',
              text2: 'mais de',
              text3: 'Instituições de Ensino'
            },
            conteudos: { text1: 'Mais de', text3: 'Conteúdos interativos' }
          }
        },
        sectionSolucaoBioAtlas: {
          title:
            'BioAtlas: Uma solução robusta pensada para todos os membros <br /> da sua Instituição de Ensino de saúde humana',
          altProfessores: 'Solução para Professores',
          altAlunos: 'Solução para Alunos',
          professores: {
            title: 'Para Professores:',
            list: [
              'Conteúdo visual e atualizado para engajar alunos',
              'Crie e compartilhe coleções de conteúdo',
              'Acesso multiplataforma (celular, computador, tablet)',
              'Treinamento simples',
              'Integração com plataformas institucionais'
            ],
            button: 'Saber mais',
            staticTitle: 'Para professores',
            staticSubtitle: 'Saber mais'
          },
          alunos: {
            title: 'Para alunos:',
            list: [
              'Facilidade de compartilhamento de coleções.',
              'Acesso multiplataforma'
            ],
            button: 'Saber mais',
            staticTitle: 'Para alunos',
            staticSubtitle: 'Saber mais'
          }
        },
        sectionVantagensInstituicao: {
          title: 'Vantagens do BioAtlas para sua Instituição',
          buttons: {
            acesso: 'Acesso',
            multilingue: 'Multilíngue',
            integracao: 'Integração',
            treinamento: 'Treinamento',
            ensino: 'Ensino diversificado',
            colecoes: 'Coleções'
          },
          content: {
            acesso: {
              p1: 'O <bold>Acesso</bold> ao BioAtlas é facilitado:',
              b1: '<bold>Simplificado:</bold> Utilize login e senha institucionais (<bold>SSO - Single Sign-On</bold>) para disponibilizar acesso direto à plataforma. Alternativamente, explore as opções de acesso <bold>via EzProxy ou endereço de IP</bold> da sua universidade.',
              b2: '<bold>Multiplataforma:</bold> Conteúdo acessível em qualquer lugar e dispositivo, seja através de um navegador <bold>web</bold>, ou pelo nosso aplicativo nativo, disponível para smartphones e tablets (<bold>Android e iOS</bold>).'
            },
            multilingue: {
              p1: 'O BioAtlas foi desenvolvido com um suporte nativo para os seguintes idiomas:',
              b1: 'Português',
              b2: 'Espanhol',
              b3: 'Inglês',
              pAfter:
                'Essa funcionalidade multilíngue garante que a experiência do usuário, a interface, a navegação e o acesso à documentação sejam fluidos e intuitivos para falantes desses três idiomas, maximizando o potencial de uso e a inclusão da plataforma em diversos contextos geográficos e acadêmicos.'
            },
            integracao: {
              p1: '<bold>Integre os conteúdos</bold> nativos do BioAtlas (como modelos 3D, animações, lâminas e exames radiológicos) <bold>diretamente na plataforma educacional (ou LMS)</bold> da sua Instituição de Ensino.',
              p2: 'Garanta o <bold>aprimoramento do seu ambiente virtual</bold> com acesso simples aos recursos e suporte técnico especializado.'
            },
            treinamento: {
              p1: '<bold>Nosso time de especialistas</bold> está totalmente preparado para oferecer um treinamento completo e eficiente aos membros do corpo docente de sua instituição.',
              p2: 'Através de <bold>sessões interativas</bold> e suporte contínuo, garantimos que seus professores e instrutores adquiram as habilidades e o domínio das ferramentas necessárias para <bold>integrar as soluções BioAtlas em suas rotinas de trabalho</bold> e potencializar o processo de ensino-aprendizagem.'
            },
            ensino: {
              p1: 'O BioAtlas oferece um acervo digital rico e detalhado, com <bold>milhares de conteúdos em 3D animados</bold> de alta fidelidade para visualização interativa de estruturas biológicas complexas.',
              p2: 'A plataforma também disponibiliza uma coleção de <bold>lâminas histológicas e histopatológicas</bold> digitalizadas em alta resolução, essenciais para o estudo da microanatomia e patologias.',
              p3: 'Complementarmente, inclui um módulo robusto de <bold>diagnóstico por imagem</bold> (RM, TC, US, Raio X), permitindo a prática na interpretação de exames reais.'
            },
            colecoes: {
              p1: 'As Coleções BioAtlas possibilitam o agrupamento de conteúdos 3D, lâminas e imagens radiológicas em pastas, aplicando filtros inteligentes que conferem acesso rápido, lógico e fluido.',
              p2: 'Elas permitem que <bold>docentes estruturem aulas</bold> com maior clareza e que <bold>discentes realizem revisões com propósito</bold>, tudo integrado na mesma plataforma.',
              p3: 'Representam o elo entre conteúdo, metodologia e engajamento.'
            }
          }
        },
        sectionDepoimentos: {
          title: 'Veja o que nossos usuários estão dizendo sobre o BioAtlas',
          testimonials: [
            {
              text: 'O BioAtlas é uma excelente ferramenta para que o aluno integre os diferentes conteúdos das ciências biológicas e da saúde',
              author: 'Dr. Rodolfo Souza de Faria',
              role: 'Professor de Fisiologia Humana e Neurociências na FMIT'
            },
            {
              text: 'Muito legal ver as partes de anatomia humana de forma interativa, didática e de uma forma ter uma visão aprimorada de cada parte do corpo humano muito próxima a realidade.',
              author: 'Ana Paula Gomes Peixoto',
              role: 'Afya Faculdade de Ciências Médicas Contagem'
            },
            {
              text: 'O BioAtlas está sendo fundamental nesse momento de minha trajetória acadêmica. Material de excelente qualidade e fácil manuseio, facilitando assim, a compreensão e aprendizado.',
              author: 'Luciana De Almeida Da Cunha',
              role: 'ULBRA'
            },
            {
              text: 'Eu recomendaria sim o BioAtlas para um amigo ou colega por que ele tem conteúdos que ajudam bastante os alunos para estudar. Me ajuda nas aulas teóricas e práticas da Universidade.',
              author: 'Daniel Vieira de Souza Martins',
              role: 'Unigranrio'
            },
            {
              text: 'BioAtlas es una maravillosa plataforma de contenido médico para fortalecer el conocimiento y la práctica de estudiantes y profesionales médicos.',
              author: 'Dra Briseida Estefanía Castillón Betancourt',
              role: 'Médico Cirujano y Partero - IMSS - México'
            },
            {
              text: 'O BioAtlas é fundamental para o ensino de Anatomia e dos sistemas fisiológicos, auxiliando muito na didática docente, contribuindo para a consolidação dos conhecimentos por parte dos alunos.',
              author: 'Dra. Ludmila Alem',
              role: 'Prof. de Anatomia - UFRJ <br />Prof. de SOI - Medicina Afya | Unigranrio'
            }
          ]
        },
        logosCarousel: {
          title:
            'Confiado por instituições líderes em mais de <span>20</span> países'
        },
        collectionsPage: {
          banner: {
            title: 'Organize o conhecimento. Inspire o aprendizado.',
            subtitle: 'Coleções BioAtlas',
            text: 'As Coleções BioAtlas permitem que você agrupe os Conteúdos disponíveis em sequências didáticas, criando experiências de aprendizado visual, conectadas e fáceis de compartilhar.',
            btnText: 'Solicite apresentação'
          },
          explanation: {
            title: 'Como funcionam as Coleções',
            paragraph1:
              'As Coleções BioAtlas oferecem uma organização inteligente para seu material de estudo.',
            paragraph2:
              'Agrupe facilmente conteúdos 3D, lâminas e imagens radiológicas em pastas com filtros inteligentes, garantindo um acesso rápido, lógico e intuitivo.',
            paragraph3:
              'Na mesma plataforma, professores podem estruturar aulas com clareza, e alunos podem revisar o conteúdo com foco e propósito.',
            paragraph4:
              'As Coleções BioAtlas são o elo perfeito entre conteúdo relevante, metodologia de ensino eficaz e engajamento do aluno.',
            btnText: 'Solicitar apresentação',
            upperCards: {
              saveChanges: {
                title: 'Salve as Alterações feitas nos Conteúdos 3D',
                text: 'Personalize o conteúdo com caixas de texto, etiquetas, setas e outros elementos, salvando-o diretamente nas suas coleções.'
              },
              shareCollection: {
                title: 'Compartilhe sua coleção com facilidade',
                text: 'Com apenas um clique, você cria um link para compartilhar sua coleção com alunos e docentes.'
              }
            },
            lowerCard: {
              title: 'Organização inteligente',
              text: 'Agrupe suas coleções em pastas, use filtros por conteúdo e encontre exatamente o que precisa — em segundos.'
            }
          },
          visualizer: {
            title:
              'Aumente a interação professor-aluno e a qualidade dos estudos com as Coleções BioAtlas',
            items: {
              integratedToCurriculum: {
                btnTitle: 'Integradas ao currículo',
                text: 'Alinhe de forma estratégica e detalhada cada coleção de recursos e materiais didáticos aos objetivos de aprendizado específicos e às metodologias pedagógicas de cada disciplina curricular.'
              },
              teaching: {
                btnTitle: 'Didáticas',
                text: 'O aprendizado se torna ativo e significativo com o incentivo à interação com a coleção, revisão constante do material e compartilhamento das descobertas com colegas.'
              },
              sequential: {
                btnTitle: 'Sequencial',
                text: 'As Coleções BioAtlas organizam o conhecimento de forma significativa, ajudando o aluno a compreender a sequência lógica entre temas.'
              },
              diversified: {
                btnTitle: 'Diversificada',
                text: 'As Coleções BioAtlas permitem agrupar de maneira inteligente uma vasta gama de conteúdos digitais, incluindo modelos 3D detalhados, lâminas de microscopia virtual e imagens radiológicas, tudo em pastas personalizáveis.'
              }
            }
          }
        },
        resourcesPage: {
          banner: {
            title: 'Explore o corpo humano de um novo jeito',
            text: 'Estude Anatomia, Lâminas e Exames Radiológicos de forma integrada, prática e envolvente através dos visualizadores do BioAtlas.',
            btnText: 'Solicitar apresentação'
          },
          visualizer3d: {
            title: 'Visualizador 3D',
            subtitle: 'Ferramentas disponíveis',
            text: 'Visualize estruturas anatômicas em alta qualidade e de qualquer ângulo.',
            items: {
              chapters: {
                btnTitle: 'Capítulos',
                text: 'Muitas das animações do BioAtlas são divididas em capítulos, que ajudam a compreender os detalhes de cada conteúdo. Cada capítulo é desenhado para cobrir um aspecto específico e fundamental, garantindo que a compreensão dos temas mais complexos seja construída passo a passo, tornando o aprendizado mais eficiente e acessível.'
              },
              search: {
                btnTitle: 'Pesquisa',
                text: 'Mergulhe nas estruturas através da pesquisa dentro do visualizador e explore em detalhes o conteúdo apresentado. Esta funcionalidade permite aos usuários localizar e isolar elementos específicos com precisão.'
              },
              slice: {
                btnTitle: 'Corte',
                text: 'Através da ferramenta de corte você pode definir planos de corte precisos ao longo dos três eixos espaciais — X (largura), Y (altura) e Z (profundidade). Isso possibilita a dissecação virtual do modelo ou objeto em questão, revelando camadas, composições e detalhes que estariam ocultos na visualização superficial.'
              },
              annotations: {
                btnTitle: 'Anotações',
                text: 'Faça anotações em qualquer conteúdo, marque, destaque ou comente diretamente onde a informação reside. Adicione suas reflexões, perguntas ou resumos ao lado do conteúdo.'
              },
              tags: {
                btnTitle: 'Etiquetas',
                text: 'Utilize as etiquetas para marcar detalhes específicas e fazer consultas posteriores de forma eficiente e precisa. Esta é uma ferramenta poderosa para a organização e gestão da informação.'
              },
              flashcards: {
                btnTitle: 'Flashcards',
                text: 'Os Flashcards são recursos dentro dos conteúdos por capítulo, com o objetivo de reforçar a aprendizagem ativa, permitindo que o aluno revise conceitos de forma rápida e interativa.'
              },
              accessibility: {
                btnTitle: 'Acessibilidade',
                text: 'O BioAtlas oferece um conjunto robusto de recursos de acessibilidade e personalização meticulosamente desenvolvidos para garantir que cada usuário possa otimizar sua experiência de navegação e estudo. Recursos para facilitar o acesso e a compreensão dos conteúdos apresentados: altere o layout, tamanho de fonte e muito mais.'
              },
              animation: {
                btnTitle: 'Animação',
                text: 'Animações digitais interativas e exclusivas, meticulosamente elaboradas para serem ferramentas poderosas de ensino e aprendizado. Cada peça de conteúdo é concebida para transformar conceitos complexos em narrativas visuais envolventes, facilitando a compreensão e retenção do material pelos usuários.'
              }
            }
          },
          visualizerSlides: {
            title: 'Visualizador de lâminas histológicas',
            subtitle: 'Ferramentas',
            text: 'Lâminas digitais em alta resolução permitem observar detalhes com nitidez, aplicar zoom e comparar estruturas, tudo direto do navegador.',
            items: {
              measure: {
                btnTitle: 'Medida',
                text: 'Realize medições diretamente sobre a lâmina digital, permitindo analisar o tamanho e a proporção de estruturas histológicas com precisão. Ideal para estudos morfológicos e comparações entre tecidos.'
              },
              progressiveZoom: {
                btnTitle: 'Zoom progressivo',
                text: 'Explore a lâmina em diferentes níveis de ampliação, do campo geral aos detalhes microscópicos. O zoom progressivo simula a experiência do microscópio óptico, facilitando a compreensão gradual das estruturas celulares. Simula os níveis clássicos de microscopia óptica, permitindo alternar entre ampliações predefinidas: 2x 4x 8x 10x 20x 40x.'
              },
              marker: {
                btnTitle: 'Marcador',
                text: 'Adicione marcações personalizadas sobre a lâmina para destacar regiões de interesse, apoiar explicações e registrar observações importantes durante o estudo ou a aula.'
              },
              panoramic: {
                btnTitle: 'Panorâmica',
                text: 'Navegue livremente pela lâmina em alta resolução, explorando toda a extensão do tecido com fluidez e controle. A visualização panorâmica facilita a contextualização espacial das estruturas analisadas.'
              },
              pinsAndArrows: {
                btnTitle: 'Pins e setas',
                text: 'Utilize pins e setas para apontar e evidenciar estruturas específicas da lâmina, tornando a explicação visual mais clara e objetiva, especialmente em atividades didáticas e apresentações.'
              },
              infoPanel: {
                btnTitle: 'Painel de informações',
                text: 'Acesse informações detalhadas sobre a lâmina, como tipo de tecido, coloração, tipo de corte e descrição histológica, apoiando a interpretação correta e o aprendizado teórico integrado à imagem.'
              }
            }
          },
          visualizerDicom: {
            title: 'Visualizador de radiologia',
            subtitle: 'Ferramentas avançadas',
            text: 'Aprenda a interpretar exames de imagem com contexto clínico.',
            items: {
              reports: {
                btnTitle: 'Laudos',
                text: 'Analise laudos radiológicos de forma detalhada diretamente no visualizador, com informações importantes como modalidade do exame, região do corpo, sexo e achados, para uma melhor compreensão do estudo.'
              },
              series: {
                btnTitle: 'Séries de imagens',
                text: 'Navegue facilmente entre diferentes sequências, planos (axial, coronal, sagital) ou momentos do estudo (com e sem contraste) para uma análise completa e detalhada da anatomia e patologia. Essencial para estudos dinâmicos e para uma visão tridimensional precisa.'
              },
              measurement: {
                btnTitle: 'Medição',
                text: 'Meça distâncias, ângulos e áreas com precisão, permitindo a quantificação de achados (como o tamanho de nódulos ou a extensão de coleções) e o acompanhamento objetivo das mudanças ao longo do tempo.'
              },
              contrastControl: {
                btnTitle: 'Controle de brilho e contraste',
                text: 'Otimize a visualização de diferentes tecidos e densidades (como osso, parênquima pulmonar ou estruturas de partes moles) manipulando o brilho (nível) e o contraste (largura da janela). Esta calibração é crucial para destacar detalhes sutis e identificar lesões que, de outra forma, passariam despercebidas.'
              },
              markersAndAnnotations: {
                btnTitle: 'Anotações e marcações',
                text: 'Adicione setas, círculos, textos e outras marcações gráficas diretamente nas imagens para destacar áreas de interesse, mensurações específicas ou achados patológicos. Essas anotações são essenciais para o aprendizado e para orientar colegas durante a discussão de casos.'
              },
              multiplePanels: {
                btnTitle: 'Múltiplos painéis',
                text: 'Permite a organização da área de trabalho para exibir simultaneamente várias séries, cortes ou exames lado a lado. Essencial para a comparação rápida de diferentes modalidades (ex: TC vs. Ressonância), avaliação bilateral (ex: joelhos) ou para visualizar o mesmo achado em diferentes planos anatômicos de uma vez, otimizando o fluxo de trabalho e a correlação de informações.'
              }
            }
          },
          footer: {
            text: 'Transforme o estudo da medicina em uma jornada visual. Explore os visualizadores e vá além das imagens: uma nova forma de aprender.',
            btnText: 'Solicitar apresentação'
          }
        },
        appPage: {
          banner: {
            title:
              'BioAtlas App - aprendizado médico acessível em qualquer lugar',
            text: 'Estude através de Conteúdos 3D, Lâminas de Histologia e Exames de Radiologia utilizando o Tablet ou Smartphone, organize seus conteúdos, crie coleções e mantenha o aprendizado sempre ao seu alcance.'
          },
          visualizer: {
            title: 'Funcionalidades e diferenciais do BioAtlas App',
            items: {
              onlineOffline: {
                btnTitle: 'Acesso online e offline',
                text: 'Acesse os conteúdos do BioAtlas a qualquer momento, mesmo offline. Baixe os conteúdos e continue sua jornada de aprendizado sem interrupções.'
              },
              unifiedCollections: {
                btnTitle: 'Coleções unificadas',
                text: 'As coleções criadas na web podem ser acessadas no aplicativo BioAtlas e vice-versa.'
              },
              contentDiversity: {
                btnTitle: 'Diversidade de Conteúdos',
                text: 'Explore uma vasta biblioteca de conteúdos que o BioAtlas App oferece na palma da sua mão. Um verdadeiro hub de aprendizado médico, reunindo uma diversidade de conteúdos sem igual, acessível a qualquer hora, em qualquer local.'
              },
              flashcards: {
                btnTitle: 'Flashcards',
                text: 'Revise conceitos essenciais, teste sua memória e aprenda com mais eficiência usando os Flashcards do BioAtlas. (em breve)'
              },
              responsive: {
                btnTitle: 'Responsivo',
                text: 'A navegação em Tablets oferece uma experiência semelhante à de um desktop. Em smartphones, todo o conteúdo foi otimizado, garantindo um acesso rápido e prático na palma da mão.'
              }
            }
          }
        },
        integrationPage: {
          banner: {
            title: 'Integração Institucional',
            subtitle: 'Para instituições e parceiros',
            text: 'Transforme sua plataforma educacional com o conteúdo do BioAtlas, acesso simples e rápido e suporte técnico dedicado.',
            btnText: 'Solicite apresentação'
          },
          content: {
            title: 'Integração dos conteúdos',
            text: 'Conecte o BioAtlas ao sistema de ensino já utilizado na sua Instituição (ex.: Moodle, Canvas) para que os conteúdos sejam lançados diretamente nas disciplinas.',
            imgAlt: 'Integração dos conteúdos'
          },
          access: {
            title: 'Acesso unificado',
            paragraph1:
              'O BioAtlas dispõe de recursos para facilitar o acesso através da sua plataforma de ensino, facilitando o engajamento dos professores e alunos na ferramenta.',
            paragraph2:
              'O aluno/professor pode acessar o BioAtlas através do portal da sua instituição sem precisar de login e senha, através de integrações via SSO/EZ Proxy.',
            whyTitle: 'Por que é útil:',
            whyText:
              'Elimina a necessidade de senhas extras, reduz chamados ao suporte e torna o uso mais natural (um {highlight} login para tudo).',
            whyTextHighlight: 'único',
            btnText: 'Conversar com equipe de vendas'
          },
          api: {
            title:
              'O conteúdo 3D do BioAtlas em seu projeto através de nossa API',
            text: 'Construa uma experiência interativa virtual 3D em seu projeto relacionado à anatomia ou outras disciplinas relacionadas ao ciclo básico em Saúde. O conteúdo do BioAtlas pode ser facilmente integrável a seu website, conteúdo digital, LMS ou projeto digital através da BioAtlas API.'
          },
          institutions: {
            title: 'BioAtlas para sua instituição',
            items: {
              pharma: 'Farmacêutica',
              university: 'Universidades',
              hospital: 'Hospitais',
              publisher: 'Editoras'
            }
          },
          whiteLabel: {
            title: 'BioAtlas com a marca da sua Instituição',
            text: 'O BioAtlas possui uma solução "Private Label", que permite colocar a marca da sua Instituição tornando uma solução 100% customizada.'
          },
          embed: {
            title: 'Embarque de conteúdos',
            text: 'Embarque os conteúdos do BioAtlas (modelos 3D, animações, lâminas, radiografias) dentro do site, CMS ou do ambiente digital da sua Instituição. Nossa documentação técnica detalhada e o suporte dedicado estão prontos para auxiliar sua equipe de TI em todo o processo de implementação, garantindo uma integração rápida e bem-sucedida. Transforme a maneira como sua instituição entrega conhecimento.',
            whyTitle: 'Por que é útil?',
            whyText:
              'O estudante não precisa sair do portal da faculdade para acessar o material, tornando a experiência de utilização mais fluida e profissional.'
          },
          footer: {
            text: 'O BioAtlas foi criado para valorizar o tempo e o esforço dos estudantes, tornando o aprendizado mais acessível e prático.',
            btnText: 'Solicitar apresentação'
          }
        },
        forTeachers: {
          hero: {
            title: 'Recursos pensados para os professores.',
            text: 'O BioAtlas atua como um parceiro de ensino, potencializando o trabalho do professor. A plataforma moderniza a experiência em sala de aula e coloca o educador no centro da inovação acadêmica.',
            button: 'Solicitar apresentação'
          },
          auxiliar: {
            title: 'BioAtlas: O Seu Auxiliar Essencial para Aulas',
            tabs: {
              aulasAtrativas: 'Aulas mais <br/> atrativas',
              ferramentas: 'Ferramentas <br/> de apresentação',
              colecoes: 'Coleções <br/> Personalizadas',
              sugestoes: 'Sugestões <br/> de conteúdos'
            },
            imageAlts: {
              aulasAtrativas: 'Aulas mais atrativas',
              ferramentas: 'Ferramentas de apresentação',
              colecoes: 'Coleções Personalizadas',
              sugestoes: 'Sugestões de conteúdos'
            },
            content: {
              aulasAtrativas: {
                p1: 'Otimize a preparação de suas aulas e maximize o engajamento dos alunos com o acervo interativo do BioAtlas com milhares de conteúdos de alta fidelidade, e as ferramentas de apresentação.'
              },
              ferramentas: {
                p1: 'Aprimore suas aulas com ferramentas integradas que permitem a manipulação e personalização imediata do conteúdo:',
                b1: '<bold>Interatividade</bold>: Utilize as funções de corte e seleção de elementos nos visualizadores 3D, Lâmina e Radiologia.',
                b2: '<bold>Foco e Colaboração</bold>: Insira anotações e comentários diretamente nas estruturas e imagens para otimizar a comunicação e direcionar os participantes.'
              },
              colecoes: {
                p1: 'Com o BioAtlas, os professores têm a liberdade de modificar o conteúdo 3D para adequar às suas aulas. Além disso, podem salvar essas alterações em coleções pessoais e compartilhá-las facilmente com todos os alunos.'
              },
              sugestoes: {
                p1: 'A colaboração dos professores é fundamental para aprimorar o catálogo de ensino do BioAtlas. Os docentes podem sugerir novos conteúdos ou indicar a ausência de materiais para enriquecer e complementar suas aulas.'
              }
            }
          },
          depoimentos: {
            title:
              'Confira o que alguns de nossos usuários têm a dizer sobre o BioAtlas:',
            testimonials: [
              {
                text: '\u201cO BioAtlas é uma excelente ferramenta para que o aluno integre os diferentes conteúdos das ciências biológicas e da saúde\u201d',
                author: 'Dr. Rodolfo Souza de Faria',
                role: 'Professor de Fisiologia Humana e Neurociências na FMIT'
              },
              {
                text: '\u201cBioAtlas es una maravillosa plataforma de contenido médico para fortalecer el conocimiento y la práctica de estudiantes y profesionales médicos.\u201d',
                author: 'Dra. Briseida Estefanía Castillón Betancourt',
                role: 'Médico Cirujano y Partero - IMSS - México'
              },
              {
                text: '\u201cO BioAtlas é fundamental para o ensino de Anatomia e dos sistemas fisiológicos, auxiliando muito na didática docente, contribuindo para a consolidação dos conhecimentos por parte dos alunos.\u201d',
                author: 'Dra. Ludmila Alem',
                role: 'Prof. de Anatomia - UFRJ <br /> Prof. de SOI - Medicina Afya | Unigranrio'
              }
            ]
          },
          cta: {
            text: 'O BioAtlas oferece uma experiência de aprendizado mais<br/>prática e acessível.',
            button: 'Solicite apresentação'
          }
        },
        forStudents: {
          hero: {
            title: 'Estudo dinâmico para uma geração inquieta',
            text: 'Transforme a teoria em prática, simplifique o aprendizado e retenha a atenção dos alunos com o BioAtlas. Coloque o aluno no comando de sua própria trajetória médica.',
            button: 'Solicitar apresentação'
          },
          auxiliar: {
            title: 'Como o BioAtlas auxilia  a Rotina Acadêmica dos Alunos',
            tabs: {
              conexaoProfessores: 'Conexão com <br/> Professores',
              aprendizadoPratico: 'Aprendizado <br/> prático',
              disponivelBolso: 'Disponível <br/> no bolso',
              estudoDinamico: 'Estudo <br/> dinâmico'
            },
            imageAlts: {
              conexaoProfessores: 'Conexão com Professores',
              aprendizadoPratico: 'Aprendizado prático',
              disponivelBolso: 'Disponível no bolso',
              estudoDinamico: 'Estudo dinâmico'
            },
            content: {
              conexaoProfessores: {
                p1: 'Os estudantes têm a liberdade de acessar coleções compartilhadas pelos professores, revisar o mesmo conteúdo abordado em sala de aula e estudar de forma clara, seguindo seu próprio ritmo de aprendizado.'
              },
              aprendizadoPratico: {
                p1: 'Explore modelos 3D realistas, lâminas histológicas digitais e radiologia integrada, entendendo o corpo humano em detalhes e conexões.'
              },
              disponivelBolso: {
                p1: 'O BioAtlas oferece acesso flexível em diversos dispositivos, garantindo que os estudantes possam consultar seus materiais didáticos a qualquer momento, inclusive fora do ambiente acadêmico.'
              },
              estudoDinamico: {
                p1: 'Com coleções personalizadas e filtros inteligentes, os alunos podem selecionar o conteúdo que desejam revisar e organizar seus tópicos de estudo favoritos.'
              }
            }
          },
          depoimentos: {
            title: 'O que dizem alguns dos nossos usuários sobre o BioAtlas:',
            testimonials: [
              {
                text: '“Eu recomendaria sim o BioAtlas para um amigo ou colega por que ele tem conteúdos que ajudam bastante os alunos para estudar. Me ajuda nas aulas teóricas e práticas da Universidade.”',
                author: 'Daniel Martins Vieira',
                role: 'Estudante Unigranrio'
              },
              {
                text: '“Muito legal ver as partes de anatomia humana de forma interativa, didática e de uma forma ter uma visão aprimorada de cada parte do corpo humano muito próxima a realidade.”',
                author: 'Ana Paula Gomes Peixoto',
                role: 'Afya Faculdade de Ciências Médicas Contagem'
              },
              {
                text: '“O BioAtlas está sendo fundamental nesse momento de minha trajetória acadêmica. Material de excelente qualidade e fácil manuseio, facilitando assim, a compreensão e aprendizado.”',
                author: 'Luciana de Almeida da Cunha',
                role: 'Estudante de medicina <br /> ULBRA'
              }
            ]
          },
          cta: {
            text: 'O BioAtlas foi criado para valorizar o tempo e o esforço do estudante de medicina.<br/>Aqui, o conhecimento ganha forma, o conteúdo se conecta e o aprendizado se torna mais acessível e prático.',
            button: 'Solicitar apresentação'
          },
          aprendaInteligente: {
            title:
              'Aprenda de forma inteligente, a qualquer hora e em qualquer lugar',
            description:
              'O BioAtlas é o seu companheiro ideal para a rotina de estudos da saúde humana. Feito para acompanhar você na faculdade, em casa ou durante revisões, ele permite que você encontre o conteúdo necessário com poucos cliques. Revise para as provas e mantenha o foco no que realmente importa: aprender com clareza.',
            cards: {
              colecoes: {
                title: 'Coleções, Anotações e Marcadores Personalizados',
                description:
                  'Crie um ambiente de aprendizado totalmente personalizado. Utilize anotações e marcadores para registrar observações, destacar pontos-chave e facilitar a revisão do conteúdo essencial.'
              },
              flashcards: {
                title: 'Revise com flashcards',
                description:
                  'Com os flashcards BioAtlas, você revisa conceitos, testa seus conhecimentos e consolida o conteúdo de maneira ágil e divertida.<br/><br/>Ideal para se preparar antes das provas e aprimorar a memória de longo prazo.'
              },
              modelos: {
                title:
                  'Modelos 3D Interativos, Exames Radiológicos e Lâminas de Estudo',
                description:
                  'Explore o corpo humano de maneira integrada e visual. No BioAtlas, você pode girar, ampliar e comparar modelos anatômicos, observar lâminas histológicas digitais e correlacionar com imagens radiológicas reais.'
              }
            }
          }
        },
        facilitySection: {
          sectionTitle: 'Facilidade desde o primeiro uso',
          features: {
            treinamento: {
              cardTitle: 'Treinamento\nSimplificado',
              title: 'Treinamento Simplificado',
              description:
                'Domine todas as funcionalidades do BioAtlas, desde o primeiro acesso até recursos avançados de análise, visualização e gestão. Otimize seu fluxo de trabalho e maximize o uso da plataforma.',
              imageAlt: 'Pessoas em treinamento com tela de apresentação'
            },
            multiplataforma: {
              cardTitle: 'Acesso\nMultiplataforma',
              title: 'Acesso Multiplataforma',
              description:
                'O BioAtlas está disponível para acesso em qualquer navegador web, além de contar com aplicativos dedicados para dispositivos móveis (celulares e tablets) nas plataformas Android e iOS.',
              imageAlt: 'Dispositivos mostrando a plataforma Bioatlas'
            },
            integracao: {
              cardTitle: 'Integração com\nPlataformas Externas',
              title: 'Integração com Plataformas Externas',
              description:
                'Nosso conteúdo pode ser embarcado no site da Instituição de Ensino que você trabalha através de nossa API.',
              imageAlt: 'Monitor exibindo integração com plataformas externas'
            },
            acervo: {
              cardTitle: 'Acervo de Milhares\nde Conteúdos',
              title: 'Acervo de milhares de conteúdos',
              description:
                'O BioAtlas é uma ferramenta essencial para a excelência pedagógica, disponibilizando um vasto acervo interativo com milhares de conteúdos de alta fidelidade:',
              item1: 'Modelos 3D de Estruturas',
              item2: 'Lâminas Histológicas e Histopatológicas Detalhadas',
              item3: 'Materiais de Diagnóstico por Imagem',
              imageAlt: 'Interface do acervo de conteúdos 3D'
            }
          }
        },
        completeAnatomy: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Anatomia Completa',
            paragraph:
              'A Anatomia Humana é a ciência que estuda a morfologia e a organização do corpo humano, através da observação e análise das estruturas macroscópicas constituintes. Essa análise está correlacionada com o funcionamento das várias partes e os mecanismos de formação e de resposta aos fatores ambientais, genéticos e temporais. Pode ser categorizada, a partir da separação das peças, em Sistemas Orgânicos e Regiões Anatômicas. Nesse módulo, foram contemplados modelos anatômicos representativos do corpo masculino e do feminino, além do cadáver virtual masculino.',
            atlas3D: {
              title: 'Atlas Anatômico 3D',
              paragraph:
                'Este módulo conta com mais de 2500 estruturas identificadas, de acordo com a Terminologia Anatômica Internacional. Ele está separado em modelo Masculino e Feminino e organizado de acordo com 12 sistemas anatômicos e 9 regiões.'
            },
            atlasHumano: {
              title: 'Atlas Humano',
              paragraph:
                'O Atlas Humano é constituído por um modelo 3D formado por todos os sistemas anatômicos do corpo humano etiquetados e com um sistema de organização avançado. Desenvolvido com a máxima qualidade de texturas, o atlas garante um conjunto impressionante de dados que podem ser utilizados como referência durante a discussão de um caso, um plano cirúrgico ou aula de anatomia. Está separado em modelo feminino e masculino, além de possuir um conteúdo voltado para o estudo dos planos imaginários que dividem o corpo humano. São eles:',
              list: {
                female: 'Feminino: 2501 objetos.',
                male: 'Masculino: 2518 objetos.',
                planes: 'Planos Anatômicos: separado em duas cores, sendo:',
                delimitation: 'Planos de delimitação: 7 objetos.',
                section: 'Planos de seção: 5 objetos.'
              }
            },
            cadaver3D: {
              title: 'Cadáver Virtual 3D',
              paragraph:
                'Uma versão em 3D de um corpo humano dividido em 1878 fatias e fotografado com equipamento de altíssima resolução reconstruído digitalmente em 3D. O Cadáver Virtual possui as cores preservadas, está segmentado e mapeado para visualização completa.'
            }
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Anatomia',
            olhoHumano: 'Anatomia - Olho Humano',
            cranio: 'Anatomia - Elementos Descritivos do Crânio',
            esqueletoAxial:
              'Anatomia - Elementos Descritivos do Esqueleto Axial'
          }
        },
        topographicAnatomy: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Anatomia Topográfica',
            paragraph:
              'A Anatomia Topográfica trata do estudo da separação do corpo humano em regiões, a fim de facilitar a compreensão das relações anatômicas entre estruturas de todos os sistemas num determinado segmento do corpo. Esse método auxilia o domínio da topografia geral dos órgãos a partir da percepção de funcionamento e localização de todas as peças próximas e relacionadas. Nesse módulo, foram contempladas as regiões anatômicas: Elementos Descritivos do Crânio, cabeça e pescoço, membro superior direito, membro superior esquerdo, dorso, tórax, abdome, pelve, membro inferior direito e membro inferior esquerdo.'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Anatomia',
            ossosLongos: 'Anatomia - Anatomia Interna dos Ossos Longos',
            rinsBexiga: 'NOVIDADE - Melhorias nos modelos de rins e bexiga',
            pulmao: 'NOVIDADE - Melhorias no modelo de pulmão'
          }
        },
        systemicAnatomy: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Anatomia Sistêmica',
            paragraph:
              'A Anatomia Sistêmica trata do estudo analítico dos sistemas orgânicos do corpo humano, estabelecendo conjuntos de órgãos e peças anatômicas que executam, de maneira integrada, as mesmas funções nos mecanismos biológicos. Apesar de cada sistema realizar uma tarefa distinta, todos estão interligados, garantindo o funcionamento e a sobrevivência do organismo como um todo. Nesse módulo, foram considerados os sistemas:',
            list: {
              arterial: 'Arterial Feminino e Masculino,',
              articular: 'Articular,',
              digestorio: 'Digestório Feminino e Masculino,',
              endocrino: 'Endócrino,',
              esqueletico: 'Esquelético,',
              linfatico: 'Linfático,',
              muscular: 'Muscular,',
              nervoso: 'Nervoso Feminino e Masculino,',
              respiratorio: 'Respiratório,',
              tegumentar: 'Tegumentar Feminino e Masculino,',
              urogenital: 'Urogenital Feminino e Masculino,',
              venoso: 'Venoso Feminino e Masculino.'
            }
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Anatomia',
            digestorio: 'NOVIDADE - Atualização do Sistema Digestório Feminino',
            rinsBexiga: 'NOVIDADE - Melhorias nos modelos de rins e bexiga',
            pulmao: 'NOVIDADE - Melhorias no modelo de pulmão'
          }
        },
        cytology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Citologia',
            paragraph:
              'O módulo de Citologia permite ao usuário interagir com duas categorias de conteúdos 3D: Células e Membrana Celular. Explore as estruturas celulares em detalhe, com interatividade de ponta. Navegue nas células: Célula Eucarionte de origem animal, Célula Sanguínea, Neurônio e Fibra Muscular. Visualize um modelo de Membrana Celular em 3D e animações relacionadas ao transporte de moléculas pela membrana.'
          },
          updates: {
            title: 'Conheça nossas atualizações de Citologia',
            celulaNervosa: 'Citologia - Célula Nervosa',
            celulasSanguineas: 'Citologia - Células Sanguíneas',
            sistemaImunologico: 'Citologia - Células do Sistema Imunológico'
          }
        },
        biochemistry: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Bioquímica',
            paragraph:
              'A Bioquímica estuda os processos moleculares nos seres vivos, sendo essencial para compreender a saúde e a origem das doenças. Ao estudar biomoléculas — como proteínas, lipídios, carboidratos e ácidos nucleicos — e as complexas vias metabólicas que regulam o funcionamento celular, permite interpretar o organismo em seu nível mais fundamental. Esse conhecimento é decisivo não apenas para entender a base de processos fisiológicos e patológicos, mas também para o desenvolvimento de terapias, diagnósticos e tecnologias aplicadas à saúde. Dessa forma, a Bioquímica amplia a capacidade de investigação científica e promove uma visão integrada sobre o corpo.',
            bullet1: 'Estrutura dos Aminoácidos;',
            bullet2: 'Estrutura Secundária das Proteínas;',
            bullet3: 'Tipos de Carboidratos;',
            bullet4: 'Estrutura Terciária e Quaternária das Proteínas;',
            bullet5: 'Ação das Enzimas;',
            bullet6: 'Sinalização da Membrana Celular;',
            bullet7: 'Glicólise;',
            bullet8: 'Ciclo do Ácido Cítrico;',
            bullet9: 'Fosforilação Oxidativa;',
            bullet10: 'Gliconeogênese;',
            bullet11: 'Catabolismo dos Aminoácidos; ',
            bullet12: 'Via das Pentoses Fosfato;',
            bullet13: 'Ciclo da Ureia;',
            bullet14: 'Glicogênese;',
            bullet15: 'Radicais Livres.'
          },
          updates: {
            title: 'Conheça nossas atualizações de Bioquímica',
            celulaNervosa: 'Bioquímica - Ciclo do Ácido Crítico',
            celulasSanguineas: 'Bioquímica - Glucólisis',
            sistemaImunologico: 'Bioquímica - Módulo de Radiologia'
          }
        },
        physiology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Fisiologia',
            paragraph:
              'Explore o funcionamento e as funções normais do corpo humano, através de conteúdos virtuais 3D interativos:',
            bullet1: 'Anticorpos: classes e funções',
            bullet2: 'Ciclo cardíaco do coração',
            bullet3: 'Circulação pulmonar e sistêmica',
            bullet4: 'Contração da fibra muscular',
            bullet5: 'Geração e condução de potencial de ação',
            bullet6: 'Hematose pulmonar',
            bullet7: 'Mecanismo de feedback',
            bullet8: 'Transmissão sináptica',
            bullet9: 'Ventilação Pulmonar'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Fisiologia',
            hematosePulmonar: 'Fisiologia - Hematose Pulmonar',
            controleHiperglicemiaInsulina:
              'Fisiologia - Controle da Hiperglicemia Insulina',
            transmissaoSinaptica: 'Fisiologia - Transmissão Sináptica'
          }
        },
        histology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de análise',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Histologia',
            paragraph:
              'O BioAtlas possui um módulo dedicado ao estudo de lâminas com centenas de exemplos de glândulas, órgãos, tecidos e sistemas, e lâminas com patologias. Além de possuir uma ferramenta com recursos para visualização e análise das mesmas com zoom de até 40x, marcação nas lâminas, espelhamento, etc.'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Histologia',
            novasLaminasDescritivos:
              'NOVIDADE - Textos descritivos em todas lâminas histológicas',
            patologiaHistopatologia: 'Patologia - Histopatologia',
            histopatologiaNovasLaminas: 'HISTOPATOLOGIA - Novas Lâminas'
          }
        },
        histopathology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Histopatologia',
            paragraph:
              'Essa categoria conta com centenas de lâminas histológicas que evidenciam patologias nos tecidos e células, dos diversos sistemas e regiões anatômicas do corpo humano.',
            bullet1: 'Doenças do Sistema respiratório',
            bullet2: 'Doenças do Sistema cardiovascular',
            bullet3: 'Doenças do Sistema digestório',
            bullet4: 'Distúrbios da circulação sanguínea',
            bullet5: 'Tumor',
            bullet6: 'Doenças do Sistema nervoso',
            bullet7: 'Doenças do Sistema genital',
            bullet8: 'Doenças do Sistema urogenital',
            bullet9: 'Inflamação',
            bullet10: 'Lesão e reparo de células e tecidos',
            bullet11: 'Doenças do Sistema endócrino',
            bullet12: 'Doenças imunológicas',
            bullet13: 'Doenças dos Sistemas muscular e esquelético',
            bullet14: 'Doenças do Sistema hematopoiético'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Histopatologia',
            novidadeModuloHistopatologia: 'NOVIDADE - Módulo de Histopatologia',
            novosTextosTumor: 'Novos textos descritivos Histopatologia Tumor',
            histopatologiaNovasLaminas: 'HISTOPATOLOGIA - Novas Lâminas'
          }
        },
        embryology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Embriologia',
            paragraph:
              'Este módulo traz uma visão tridimensional do desenvolvimento humano, da zigogênese, o desenvolvimento embrionário e fetal, a placenta e membranas fetais com altíssimo nível de detalhes. A interatividade de ponta, aliada ao acesso online, torna-se um diferencial único no estudo do desenvolvimento.'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Embriologia',
            placentaDetalhes: 'Embriologia - Placenta em Detalhes',
            gestaoGemelar: 'Embriologia - Gestação Gemelar',
            visaoGeral: 'Embriologia - Visão Geral'
          }
        },
        radiology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas da saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar apresentação'
          },
          sidebar: {
            title: 'Conheça mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Radiologia',
            paragraph:
              'Sistema para visualização de imagens DICOM com ferramentas para manipulação de estudos e casos clínicos radiológicos. Permite visualizar imagens de diversas modalidades como:',
            bullet1: 'Tomografias computadorizadas;',
            bullet2: 'Ressonâncias magnéticas;',
            bullet3: 'Radiografias computadorizadas;',
            bullet4: 'Raio-X;',
            bullet5: 'Ultrassom.'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Radiologia',
            update1: 'Radiologia - Crânio e Elementos Descritivos',
            update2: 'Radiologia - Olho Humano',
            update3: 'Radiologia - Ossos Longos'
          }
        },
        pathology: {
          hero: {
            title: 'Explore o Corpo Humano em detalhes',
            text: 'Conteúdos que facilitam o aprendizado das disciplinas de saúde humana através da interatividade. Integra as áreas das Ciências Morfológicas, Ciências Fisiológicas, Ciências Humanas e Ciências Sociais Aplicadas à Saúde.',
            button: 'Solicitar demonstração'
          },
          sidebar: {
            title: 'Conhecer mais sobre os módulos de ensino',
            button: 'Solicitar apresentação'
          },
          main: {
            title: 'Patologia',
            paragraph:
              'A Patologia é a ciência que estuda as alterações estruturais, bioquímicas e funcionais nas células, tecidos e órgãos, que servem de base para a manifestação das doenças. A partir do estudo da etiologia (causas), patogenia (mecanismos de desenvolvimento) e alterações morfológicas (alterações estruturais nas células e órgãos) e fisiopatologia (consequências funcionais das alterações morfológicas), ela busca compreender o funcionamento do organismo nos processos de saúde e de doença.',
            section1Title: 'Condições patológicas',
            section2Title: 'Patologia geral',
            bullet1_1: 'Acne',
            bullet1_2: 'Afecções pleurais',
            bullet1_3: 'Anemia falciforme',
            bullet1_4: 'Asma',
            bullet1_5: 'Cardiopatia isquêmica',
            bullet1_6: 'Desvios da coluna vertebral',
            bullet1_7: 'Diabetes mellitus Tipo 01',
            bullet1_8: 'Diabetes mellitus Tipo 02',
            bullet1_9: 'Distensão muscular',
            bullet1_10: 'Doença de Graves',
            bullet1_11: 'Doença ulcerosa péptica',
            bullet1_12: 'Gastrite',
            bullet1_13: 'Fraturas ósseas',
            bullet1_14: 'Pneumonia',
            bullet1_15: 'Síndrome do ovário policístico',
            bullet1_16: 'Sinusite',
            bullet1_17: 'Tireoidite de Hashimoto',
            bullet1_18: 'Trombose',
            bullet1_19: 'Tromboembolismo pulmonar',
            bullet1_20: 'Tuberculose',
            bullet1_21: 'Urticária',
            bullet2_1: 'Adaptação celular',
            bullet2_2: 'Adaptação tecidual',
            bullet2_3: 'Morte celular (necrose)',
            bullet2_4: 'Lesões reversíveis ou irreversíveis',
            bullet2_5: 'Acúmulo intracelular (esteatose)',
            bullet2_6: 'Reparo tecidual',
            bullet2_7: 'Distúrbio hemodinâmico - inflamação',
            bullet2_8: 'Distúrbio do crescimento',
            bullet2_9: 'Alterações circulatórias - hiperemia/congestão',
            bullet2_10: 'Alterações circulatórias - isquemia/infarto',
            bullet2_11: 'Calcificação Patológica',
            bullet2_12: 'Neoplasia'
          },
          updates: {
            title: 'Conheça nossas atualizações do conteúdo de Patologia',
            update1: 'Patologia - Tromboembolismo Pulmonar',
            update2: 'Patologia - Acne',
            update3: 'Patologia - Gastrite'
          }
        }
      }
    }
  }
}

export { messages }
